import React, { Component } from "react";
import { connect } from "react-redux";
import constants from "../../globalization";
import { TimeConstants } from "../../constants";
import {
  LogLevelEnum,
  SourceTypes,
  NotificationType,
  checkEnum,
  storeProductionEnum,
} from "../../enums";
import {
  updateStatusType,
  updateNotificationType,
  updateNotification,
  updateCheckSort,
} from "../../store/actions/notification";
import { acknowledgeNoticationAction } from "../../store/actions/notifications";
import { getPopupConfig } from "../../components/Popup";
import FireboardUtils from "../../util/fireboard-util";
import MenuUTIL from '../../util/menu-utils';
import DBManager from "../../services/db-manager";
import API from "../../requests";
import CommonUtil from "./common";
import { tableReceipt } from "../../store/actions/tables";
import { printReceipt } from "../../store/actions/receipt";
import data from "./components/Header/constants";
import { login as loginAction } from '../../store/actions/login';

import View from "./views";
import UTIL from "mroads-js-utils";
import UTILLib from "../../util";
import { filterInfo } from "./data";
import EventEmitter from '../../util/event-emitter';
import { version } from '../../../package.json';
import RethinkUTIL from "../../util/rethink-db";
import { getPickerData } from "../../components/CountryPicker";
import withSocketContext from '../../context-api/SocketContext/withSocketContext';
import { updateComponentState } from '../../store/actions/component-state';
import { retryPOSPayment } from "../../store/actions";
import moment from "moment";
import { toast } from 'react-toastify';
import modeEnums from "../../enums/modeEnums";
import { updateFbCheckFilters } from "../../store/actions/fb-check-filters";
import schedule from 'node-schedule';

const US_COUNTRY_CODE = 'us';
const UK_COUNTRY_CODE = 'gb';

const NOTIFICATION = "notification";

const allOrderType = {
  externalId: "0",
  id: 0,
  name: "All",
  shortName: null,
};

const POPUPS_ENUMS = {
  SMS: "sms",
  GENERATE_QR: "generate-qr",
  GENERATE_QR_PAY: "generate-qr-pay",
  MEMBER_DETAILS: "member-details",
  GENERATE_QR_JOIN_CHECK: "generate-qr-join-check",
};

const allStoreOption = {
  value: 0,
  label: 'All',
};

const InProgressOrderStatus = [{ label: constants.orderInProgress, value: constants.orderInProgress }];
const ALLOPTION = [{ label: constants.orderTypeAll, value: constants.orderTypeAll }];

class Fireboard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      shapes: new Map(),
      updatedShapes: new Map(),
      filteredChecklist: [],
      isFetching: false,
      popup: undefined,
      isDevEnvironment: false,
      orderType: ALLOPTION,
      orderStatusType: InProgressOrderStatus,
      value: "",
      notificationControlEnabled: false,
      countStatus: {
        curbside: true,
        online: true,
        walkup: true,
      },
      snoozeEnabled: false,
      selectedItem: {},
      items: [],
      showNotifications: false,
      fromFooter: false,
      preAuthItem: {},
      managerMode: false,
      pendingCheckItems: [],
      notificationTypes: [],
      activeMgrFilter: 'pre-auth',
      counters: [],
      selectedReason: {},
      currentView: 'list',
      selectedTable: null,
      sensorData: {},
      sortFilter: false,
      outOfStockMode: '',
      outOfStockItems: [],
      outOfStockSearchList: [],
      isClickedOutOfStock: false,
      loginInfo: null,
      isCustomSmsType: true,
      customSmsList: [],
      venueOrder: true,
      foodRunner: true,
      selectedCountry: {},
      batchPreauth: false,
      pagination: false,
      currentMode: modeEnums.DEFAULT,
      includeUnavailable: false,
      twoDimensionSlot: [[]],
      fbVenueMode: false,
      multipleStores: [],
      selectedVenueStore: allStoreOption,
      venueName: '',
      selectedShape: null,
      productionOverrideReasons: [],
      selectedDate: null,
    };

    this.checks = new Map();
    this.checkSubscriber = null;
    this.allowSyncData = false;
    this.filteredCheckItems = [];
    this.notificationTimeout = null;
    this.notificationTimestamp = new Date().getTime();
    this.snoozeTimeInterval = null;
    this.notificationSubscriber = null;
    this.requestClicked = false;
    this.onIntialize = null;
    this.futureCheckItems = [];
    this.allowPairWatch = false;
    this.checksRetrieved = false;
    this.tableChecks = new Map();
    this.sensorGroupsList = [];
    this.sensorGroup = {};
    this.notifyOrderPrepared = {};
    this.notifyOrderReady = {};
    this.bulkPreAuthChecks = [];
    this.activeCheckFilter = 'sourceType';
    this.checkSourceTypes = [];
    this.checkOrderTypes = [];
    this.checkRevenueTypes = [];
    this.checkSensorGroupTypes = [];
    this.notificationSourceTypes = [];
    this.notificationOrderTypes = [];
    this.notificationRevenueTypes = [];
    this.notificationSensorGroupTypes = [];
    this.searchedVoucher = {};
    this.productionRateList = [];
    this.productionRateForEdit = null;
    this.productionRateIdsForEdit = [];
    this.storeCubbySlotsMap = new Map();
    this.cubbyLayoutPopupType = '';
    this.elapsedTimer = null;
    this.seatId = null;
    this.sensorsMap = new Map();
    this.allowExternalAppLaunch = false;
    this.employeeIdForExternalApp = null;
    this.prevOrderType = ALLOPTION;
    this.prevOrderStatusType = ALLOPTION;
    this.prevVenueStore = allStoreOption;
    this.bulkTextToPayChecks = [];
    this.ticket = {};
    this.storeLayoutBySensorGroup = false;
    this.layoutJson = null;
    this.enableAgeVerification = false;
    this.enableAgeRestrictedOrderingForSeat = false;
    this.enableAgeRestrictedOrderingForCheck = false;
    this.ageRestrictedItemsForSeat = {};
    this.overrideStoreProductionPayload = null;
    this.showFutureOrders = false;
  }

  currency = this.props?.reduxProps?.currencyInfo?.currency || '$';
  countriesData;
  sortModel = {};
  redeemOnlyVoucher = false;

  componentDidMount() {
    const {
      history,
      reduxProps: { storeInfo, deviceInfo, checkSortReducer },
    } = this.props;

    if (window.ReactNativeWebView) {
      EventEmitter.addLogs(
        'appLogs',
        LogLevelEnum.INFO,
        `Mounting Fireboard component with storeId ${storeInfo?.data?.id} and deviceExternalId ${deviceInfo?.deviceExternalId}`
      );
    }

    if (!storeInfo.data || !deviceInfo.deviceExternalId) {
      history.push({
        pathname: '/',
        state: { deviceTypeId: 15 }
      });
      return;
    }

    this.countriesData = getPickerData();
    const countryCode = this.currency === '£' ? UK_COUNTRY_CODE : US_COUNTRY_CODE;
    this.state.selectedCountry = this.countriesData.find(country => country.iso2 === countryCode);

    if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
      this.state.isDevEnvironment = true;
    }
    this.buildSensorsHashTable();
    this.setDeviceGroupData();

    const { guestAppFeatures, enableVenueOrdering = false, enableFoodRunner = false, serverAppFeatures } = storeInfo?.data || {};
    const { supportsCurbsideOrdering, supportsOnlineOrdering, supportsWalkUpOrdering } = guestAppFeatures || {};
    this.state.countStatus = {
      curbside: supportsCurbsideOrdering,
      online: supportsOnlineOrdering,
      walkup: supportsWalkUpOrdering,
    };
    this.state.venueOrder = enableVenueOrdering;
    this.state.foodRunner = enableFoodRunner;
    const { data: { sortModel } } = checkSortReducer || {};
    this.sortModel = sortModel;

    this.storeLayoutBySensorGroup = serverAppFeatures?.storeLayoutBySensorGroup || false;
    if (!this.storeLayoutBySensorGroup) { //if flag is false - call store layout by storeId
      this.getStoreLayout(storeInfo?.data?.id);
    }
    this.getCustomSmsTemplates();

    if (window.ReactNativeWebView) {
      EventEmitter.sendAppMode(version);
      this.scanToRedeemListener = message => this.onVoucherScanned(message);
      EventEmitter.addListeners('onVoucherScanned', this.scanToRedeemListener);
    }

    //get order status filter from redux props and set to the dropdown
    this.setOrderStatusFilter();

    const { context, dispatchUpdateCompState } = this.props;
    this.setChecks(context?.checks);
    dispatchUpdateCompState && dispatchUpdateCompState({ mounted: true });

    //set venue information
    this.setMultipleStores(context);

    //get store production rate and override reasons
    this.getProductionRate();

    //schedule a job - job will execute at minute 1 past every hour
    schedule.scheduleJob('1 */1 * * *', () => {
      this.setPrepWindowAndProduction();
    });
  }

  componentWillUnmount() {
    const { dispatchUpdateCompState } = this.props;
    dispatchUpdateCompState && dispatchUpdateCompState({ mounted: false });
    if (window.ReactNativeWebView) {
      this.scanToRedeemListener && EventEmitter.removeListeners('onVoucherScanned', this.scanToRedeemListener);
    }
    this.stopIntervalForTimeUpdate();
    schedule.gracefulShutdown();
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    const { reduxProps, location } = newProps;
    const { reduxProps: prevReduxProps } = this.props;
    const { tableReceiptPrint, printReceipt } = reduxProps;
    const { managerMode } = this.state;

    this.handleRetryPOSPayment(reduxProps);
    this.handleLoginAction(reduxProps);
    if (
      location &&
      location.state &&
      location.state.managerMode &&
      location.state.managerMode !== managerMode
    ) {
      const { managerMode: updatedMode } = location.state;
      this.setState({ managerMode: updatedMode, selectedItem: {}, items: [] });
    }
    if (prevReduxProps.tableReceiptPrint.timestamp !== tableReceiptPrint.timestamp) {
      if (tableReceiptPrint.isFetching) {
        this.getSpinner('spinner', constants.printLoading, null);
      } else if (tableReceiptPrint.error) {
        this.getSpinner('error', null, tableReceiptPrint.error);
      } else if (tableReceiptPrint.data) {
        const printPopup = getPopupConfig('spinner');
        printPopup.heading = `${constants.printWithStation} ${tableReceiptPrint.data.printerName}`;
        this.setState({ popup: printPopup });
        var data = {
          type: "print",
          data: tableReceiptPrint.data,
        };
        const errorMsg = "Trying to connect to " + tableReceiptPrint.data.printerName + " with IP Address " + tableReceiptPrint.data.printerIpAddress + " and port " + tableReceiptPrint.data.printerPort + " ";
        UTILLib.printReceipt(
          data,
          () => this.dismissPopup(),
          error => this.getSpinner('error', null, errorMsg + error),
          () => {
            let popup = getPopupConfig('error', () => this.dismissPopup());
            popup.message = constants.extensionNotAvailable;
            this.setState({ popup });
          },
        );
        setTimeout(() => {
          this.dismissPopup();
        }, 4000);
      }
    }

    if (prevReduxProps.printReceipt.timestamp !== printReceipt.timestamp) {
      if (printReceipt.isFetching) {
        this.getSpinner('spinner', constants.printLoading, null);
      } else if (printReceipt.error) {
        this.getSpinner('error', null, printReceipt.error);
      } else if (printReceipt.data) {
        const printPopup = getPopupConfig('spinner');
        printPopup.heading = `${constants.printWithStation} ${printReceipt.data.printerName}`;
        this.setState({ popup: printPopup });
        var data = {
          type: "print",
          data: printReceipt.data,
        };
        const errorMsg = "Trying to connect to " + printReceipt.data.printerName + " with IP Address " + printReceipt.data.printerIpAddress + " and port " + printReceipt.data.printerPort + " ";
        UTILLib.printReceipt(
          data,
          () => this.dismissPopup(),
          error => this.getSpinner('error', null, errorMsg + error),
          () => {
            let popup = getPopupConfig('error', () => this.dismissPopup());
            popup.message = constants.extensionNotAvailable;
            this.setState({ popup });
          },
        );
        setTimeout(() => {
          this.dismissPopup();
        }, 4000);
      }
    }

    if (this.props?.context !== newProps?.context) {
      const { context: nextContext } = newProps;
      if (nextContext.errorOrderFlag) {
        //if errorOrderFlag is true(received error check update) - show error order popup
        this.state.popup = { type: 'errorOrder' };
      }
      this.setChecks(nextContext?.checks, nextContext?.deletedChecks);
      if (nextContext?.newNotifications && nextContext.newNotifications.length) {
        this.handleNewNotification(nextContext.newNotifications);
      }
      //update venue information when socket context change
      this.setMultipleStores(nextContext);
    }

    if (prevReduxProps?.checkSortReducer !== reduxProps?.checkSortReducer) {
      const { checkSortReducer } = reduxProps
      const { pagination } = checkSortReducer?.data || {};
      this.setState({ pagination });
    }

    //auto close notification screen once all notifications have been dismissed
    if (prevReduxProps?.notifications !== reduxProps?.notifications) {
      const { notifications } = reduxProps;
      const notificationCount = Array.isArray(notifications) ? notifications.length : 0;
      if (notificationCount === 0) {
        this.setState({ showNotifications: false });
      }
    }
  }

  setDeviceGroupData = () => {
    const { reduxProps: { deviceApi, deviceApiData, storeInfo }, history, context } = this.props;
    const { deviceGroup } = deviceApi?.data || deviceApiData || {};
    if (deviceGroup && !FireboardUtils.isObjectBlank(deviceGroup)) {
      const {
        notificationTypeFilters,
        fireBoardSettings,
        checkChannelFilters,
        checkOrderTypeFilters,
        checkRevenueCenterFilters,
        checkSensorGroupFilters,
        notificationChannelFilters,
        notificationOrderTypeFilters,
        notificationRevenueCenterFilters,
        notificationSensorGroupFilters,
        startMode,
      } = deviceGroup || {};
      //If startMode == 3 -> start fireboard in "Cubby Manager Mode"
      if (startMode === 3) {
        history && history.push({ pathname: '/cubbyManager' });
        return;
      }
      if (startMode === 5) {
        history && history.push({ pathname: '/orderStatusManager' });
        return;
      }
      if (startMode === 2 || startMode === 4) {
        const pathname = startMode === 2 ? '/tableDelivery' : '/gpsLocationDelivery';
        const mode = startMode === 2 ? modeEnums.TABLE_DELIVERY : modeEnums.GPS_LOCATION;
        if (!context.isTblDeliveryMounted) {
          context.setTblDeliveryMounted();
          history && history.push({
            pathname,
            state: { mode },
          });
        }
        return;
      }

      switch (startMode) {
        case 0:
          this.state.currentMode = modeEnums.DEFAULT;
          break;
        case 1:
          this.state.currentMode = modeEnums.VOUCHER;
          break;
        default:
          this.state.currentMode = modeEnums.DEFAULT;
          break;
      }

      const { notificationTypes: nTypes } = storeInfo?.data || {};
      let updatedNotificationTypes = nTypes.filter(n => n.id !== 16 && n.id !== 19 && n.id !== 20);
      const { managerMode } = this.state;
      if (!managerMode) {
        updatedNotificationTypes = updatedNotificationTypes.filter(type => type.id !== 14 && type.id !== 15);
      }

      this.state.currentView = fireBoardSettings?.tileView ? 'card' : 'list';
      this.state.pagination = fireBoardSettings?.paginatedView;
      this.state.sortFilter = fireBoardSettings?.showMostCurrentCheckFirst;
      this.state.counters = CommonUtil.getCountersFromDeviceGroup(fireBoardSettings);
      this.activeCheckFilter = CommonUtil.getActiveFilterSourceFromDeviceGroup(fireBoardSettings);
      this.checkSourceTypes = CommonUtil.getODOrderTypes(checkChannelFilters);
      this.checkOrderTypes = CommonUtil.getPOSOrderTypes(checkOrderTypeFilters, storeInfo?.data?.orderTypes);
      this.checkRevenueTypes = CommonUtil.getRevenueCenterOrderTypes(checkRevenueCenterFilters, storeInfo?.data?.revenueCenters);
      this.checkSensorGroupTypes = CommonUtil.getSensorGroupOrderTypes(checkSensorGroupFilters, storeInfo?.data?.sensorGroups);
      this.notificationSourceTypes = CommonUtil.getODOrderTypes(notificationChannelFilters);
      this.notificationOrderTypes = CommonUtil.getPOSOrderTypes(notificationOrderTypeFilters, storeInfo?.data?.orderTypes);
      this.notificationRevenueTypes = CommonUtil.getRevenueCenterOrderTypes(notificationRevenueCenterFilters, storeInfo?.data?.revenueCenters);
      this.notificationSensorGroupTypes = []; //CommonUtil.getSensorGroupOrderTypes(notificationSensorGroupFilters, storeInfo?.data?.sensorGroups);
      this.state.notificationTypes = CommonUtil.getNotificationTypeNameFromDeviceGrp(notificationTypeFilters, updatedNotificationTypes);
      this.enableAgeVerification = fireBoardSettings?.enableAgeVerification || false;
      this.enableAgeRestrictedOrderingForSeat = fireBoardSettings?.enableAgeRestrictedOrderingForSeat || false;
      this.enableAgeRestrictedOrderingForCheck = fireBoardSettings?.enableAgeRestrictedOrderingForCheck || false;
    } else {
      const { reduxProps } = this.props;
      const { checkSortReducer, notificationsTypesPersist, storeTypesPersist } = reduxProps;
      const { activeCheckFilter, counterTypes, sourceTypes, orderTypes, revenueTypes, sensorGrpTypes, notificationTypes } = storeTypesPersist?.data || {};
      const { data: { sortFilter, pagination, viewType = 'list' } } = checkSortReducer || {};
      const { sourceType: nSourceType, orderType: nOrderType, revenueCenter: nRevenueCenter, sensorGrpTypes: nSensorGrpTypes } = notificationsTypesPersist?.data || {};

      this.state.currentView = viewType;
      this.state.pagination = pagination;
      this.state.sortFilter = sortFilter || false;
      this.state.counters = counterTypes || [];
      this.activeCheckFilter = activeCheckFilter || 'sourceType';
      this.checkSourceTypes = sourceTypes || [];
      this.checkOrderTypes = orderTypes || [];
      this.checkRevenueTypes = revenueTypes || [];
      this.checkSensorGroupTypes = sensorGrpTypes || [];
      this.notificationSourceTypes = nSourceType || [];
      this.notificationOrderTypes = nOrderType || [];
      this.notificationRevenueTypes = nRevenueCenter || [];
      this.notificationSensorGroupTypes = []; //nSensorGrpTypes || [];
      this.state.notificationTypes = notificationTypes || [];
    }

    if (this.state.currentMode === modeEnums.DEFAULT || this.state.currentMode === modeEnums.VOUCHER) {
      this.startIntervalForTimeUpdate();
    }

    if (this.activeCheckFilter === "sourceType") {
      this.setOrderType(this.checkSourceTypes, this.toggleSelection);
    } else if (this.activeCheckFilter === "orderType") {
      this.setOrderType(this.checkOrderTypes, this.toggleSelection);
    } else if (this.activeCheckFilter === "revenueCenter") {
      this.setOrderType(this.checkRevenueTypes, this.toggleSelection);
    } else if (this.activeCheckFilter === "sensorGroup") {
      this.setOrderType(this.checkSensorGroupTypes, this.toggleSelection);
    }
  };

  setChecks = (checks, deletedChecks) => {
    const allChecks = Array.from(checks.values());
    let checksMap = new Map();
    allChecks && allChecks.forEach(check => {
      const existingCheck = this.checks.get(check.id);
      let updatedCheck = check;
      if (existingCheck) {
        updatedCheck = { ...check, selectedForBatchPreauth: existingCheck.selectedForBatchPreauth || false };
      }
      checksMap.set(check.id, CommonUtil.parseCheckFromRedis(updatedCheck));
    });
    this.checks = checksMap;
    this.toggleSelection(true);
    this.refreshCubby();
  };

  handleNewNotification = newNotifications => {
    const {
      dispatchUpdateNotification,
      context,
      reduxProps: { notifications },
    } = this.props;
    const { updateNotification } = context;

    newNotifications.forEach(res => {
      if (res.value.notificationTypeId === 16) { //hide notification of notificationTypeId 16
        updateNotification && updateNotification(res.value.notificationId);
        this.setOrderTypeStatus(res.value);
        return;
      }

      const { notificationControlEnabled } = this.state;
      const tempNotifications = [...notifications];
      let isNew = false;
      const notificationTimes = new Date().toISOString();
      let enabled = notificationControlEnabled;
      const activeNotificationFilter = this.activeCheckFilter;
      let nOrderTypes = this.getNotificationOrderTypes();

      if (
        res.value &&
        activeNotificationFilter !== null &&
        activeNotificationFilter !== undefined &&
        nOrderTypes.length > 0
      ) {
        const dataType = this.getOrderTypeValue(activeNotificationFilter, res.value);
        const hasOrderType = dataType === constants.orderType_POS
          ? (nOrderTypes.includes(constants.orderType_POS) || nOrderTypes.includes(constants.orderType_Table) || nOrderTypes.includes(constants.orderType_Tab))
          : nOrderTypes.includes(dataType);
        if (!hasOrderType) {
          updateNotification && updateNotification(res.value.notificationId);
          return;
        }
      }

      switch (res.type) {
        case "add":
        case "initial":
        case "update":
        case "change": {
          const notificationIndex = tempNotifications.findIndex(notification =>
            notification.notificationId === res.value.notificationId
          );
          if (notificationIndex !== -1) {
            const updatedValue = {
              ...res.value,
              isNew: tempNotifications[notificationIndex].isNew || false,
              isDismissed:
                tempNotifications[notificationIndex].isDismissed || false,
              notificationTimes:
                tempNotifications[notificationIndex].notificationTimes ||
                notificationTimes,
            };
            tempNotifications.splice(notificationIndex, 1, updatedValue);
          } else {
            isNew = true;
            enabled = res.value.notificationTypeId !== NotificationType.SERVER_APP_PRINTER;
            clearInterval(this.snoozeTimeInterval);
            const updatedVal = {
              ...res.value,
              isNew,
              isDismissed: false,
              notificationTimes,
            };
            tempNotifications.push(updatedVal);
          }
          break;
        }
        default:
          console.info("notification type not handled", res.type);
      }

      this.state.notificationControlEnabled = enabled;
      this.state.snoozeEnabled = false;
      dispatchUpdateNotification(tempNotifications);
      updateNotification && updateNotification(res.value.notificationId);
      this.notificationTimeout && clearTimeout(this.notificationTimeout);
      this.notificationTimeout = setTimeout(() => {
        this.notificationTimestamp = new Date().getTime();
      }, 50);
    });
  };

  handleLoginAction = reduxProps => {
    const { reduxProps: prevReduxProps } = this.props;
    const { login } = reduxProps;
    if (login.timestamp !== prevReduxProps.login.timestamp) {
      if (login.data) {
        if (this.allowPairWatch) {
          this.setState({ loginInfo: login.data, popup: { type: "pairWatch" } });
          this.allowPairWatch = false;
          return;
        }
        if (this.allowExternalAppLaunch) {
          this.allowExternalAppLaunch = false;
          this.setState({ popup: undefined }, () => this.launchExternalApp());
          return;
        }
        //persist orderType, orderStatusType, selectedVenueStore filters before entering to manager mode
        const { orderType, orderStatusType, selectedVenueStore } = this.state;
        this.prevOrderType = orderType;
        this.prevOrderStatusType = orderStatusType;
        this.prevVenueStore = selectedVenueStore;
        this.setState({
          managerMode: true,
          selectedItem: {},
          items: [],
          popup: undefined,
          orderType: ALLOPTION,
          orderStatusType: ALLOPTION,
          selectedVenueStore: allStoreOption,
        }, () => {
          this.toggleSelection(true);
        });
      } else if (login.error) {
        this.allowPairWatch = false;
        this.allowExternalAppLaunch = false;
        this.getPopup('error', null, login.error, null);
      } else {
        this.getPopup('spinner', constants.loginLoadingHeading, null);
      }
    }
  };

  reSync = () => {
    const { reduxProps: { storeInfo }, context } = this.props;
    const { cachingProvider } = storeInfo?.data || {};
    if (cachingProvider) { //resync with CApi Websocket
      this.getPopup('spinner', constants.sync, null);
      const { getStoreChecksCApi, getStoreNotificationsCApi, getVenueChecksCApi } = context;
      const successCallback = () => {
        this.setState({ popup: undefined });
      };
      if (this.state.fbVenueMode) { //if fb venue mode is enabled
        getVenueChecksCApi && getVenueChecksCApi(successCallback);
      } else {
        getStoreChecksCApi && getStoreChecksCApi(successCallback);
      }
      getStoreNotificationsCApi && getStoreNotificationsCApi(successCallback);
    } else { //resync with YApi Websocket
      const callback = () => {
        this.getPopup('spinner', constants.sync, null);
        this.unsubscribeRethinkListeners();
        this.onIntialize = DBManager.addListener('initialize', this.reSync);
        this.checks = new Map();
        const successCallback = () => {
          this.setState({ popup: undefined });
        };
        EventEmitter.addLogs(
          'syncLogs',
          LogLevelEnum.INFO,
          'Syncing with your POS'
        );
        this.getDataFromRedis(successCallback);
      };
      callback();
    }
  };

  unsubscribeRethinkListeners = () => {
    this.onIntialize && this.onIntialize();
  };

  getOrderType = (orderTypes) => {
    let setOrderType = orderTypes;
    if (orderTypes.length === 0) {
      setOrderType = [allOrderType.name];
    } else if (!orderTypes.includes(allOrderType.name)) {
      setOrderType = [allOrderType.name, ...orderTypes];
    }
    return setOrderType;
  };

  setOrderType = (sourceTypes = [], callback) => {
    //get persisted order types from redux props and set as default selected order types
    const { reduxProps } = this.props;
    const { fbCheckFilters } = reduxProps;
    const { odOrderTypeFilters, posOrderTypeFilter, revenueCenterTypeFilter, sensorGroupTypeFilter } = fbCheckFilters || {};
    let persistedOrderTypes = ALLOPTION;
    if (this.activeCheckFilter === 'sourceType' && Array.isArray(odOrderTypeFilters) && odOrderTypeFilters.length > 0) {
      persistedOrderTypes = odOrderTypeFilters;
    } else if (this.activeCheckFilter === 'orderType' && Array.isArray(posOrderTypeFilter) && posOrderTypeFilter.length > 0) {
      persistedOrderTypes = posOrderTypeFilter;
    } else if (this.activeCheckFilter === 'revenueCenter' && Array.isArray(revenueCenterTypeFilter) && revenueCenterTypeFilter.length > 0) {
      persistedOrderTypes = revenueCenterTypeFilter;
    } else if (this.activeCheckFilter === 'sensorGroup' && Array.isArray(sensorGroupTypeFilter) && sensorGroupTypeFilter.length > 0) {
      persistedOrderTypes = sensorGroupTypeFilter;
    }
    const orderTypeList = this.getOrderTypes();
    let orderType = persistedOrderTypes.filter(eachType => orderTypeList.includes(eachType.value));
    if (orderType.length === 0) {
      orderType = ALLOPTION;
    }

    this.setState(
      {
        orderType: orderType,
      },
      () => callback && callback()
    );
  };

  getNotificationOrderTypes = () => {
    let nOrderTypes = [];
    if (this.activeCheckFilter === 'sourceType') nOrderTypes = this.notificationSourceTypes;
    else if (this.activeCheckFilter === 'orderType') nOrderTypes = this.notificationOrderTypes;
    else if (this.activeCheckFilter === 'revenueCenter') nOrderTypes = this.notificationRevenueTypes;
    else if (this.activeCheckFilter === 'sensorGroup') nOrderTypes = this.notificationSensorGroupTypes;
    return nOrderTypes;
  };

  getSelectedCheckOrderTypes = () => {
    let chkOrderTypes = [];
    if (this.activeCheckFilter === 'sourceType') chkOrderTypes = this.checkSourceTypes;
    else if (this.activeCheckFilter === 'orderType') chkOrderTypes = this.checkOrderTypes;
    else if (this.activeCheckFilter === 'revenueCenter') chkOrderTypes = this.checkRevenueTypes;
    else if (this.activeCheckFilter === 'sensorGroup') chkOrderTypes = this.checkSensorGroupTypes;
    return chkOrderTypes;
  };

  setNotificationType = (notificationTypes, callback) => {
    this.setState(
      {
        notificationTypes,
      },
      () => callback && callback(),
    );
  };

  getDataFromRedis = (callback) => {
    const { reduxProps, dispatchUpdateNotification } = this.props;
    const { notifications } = reduxProps;

    this.getAllChecks(callback);

    this.getNotifications((error, response) => {
      if (error) {
        EventEmitter.addLogs(
          'syncLogs',
          LogLevelEnum.ERROR,
          "Get notifications errored out"
        );
        const errorMsg = error.response
          ? error.response.data
          : error.message;
        this.getPopup("error", null, errorMsg);
        return;
      }
      EventEmitter.addLogs(
        'syncLogs',
        LogLevelEnum.INFO,
        `Response from get notifications.`
      );
      this.notificationTimeout && clearTimeout(this.notificationTimeout);
      this.notificationTimestamp = new Date().getTime();
      response &&
        response.forEach((n) => {
          n.notificationId = n.id;
          const existingNotification = notifications
            ? notifications.find(
              (eachNotification) =>
                eachNotification.notificationId === n.notificationId
            )
            : null;
          if (existingNotification) {
            n.isNew = existingNotification.isNew;
            n.isDismissed = existingNotification.isDismissed;
            n.notificationTimes =
              existingNotification.notificationTimes ||
              new Date().toISOString();
          } else {
            n.isNew = false;
            n.isDismissed = false;
            n.notificationTimes = new Date().toISOString();
          }
        });
      dispatchUpdateNotification(response);
    });
  };

  setOrderTypeStatus = (notification) => {
    if (notification.sourceType === SourceTypes.CurbSide) {
      this.state.countStatus.curbside = notification.sourceTypeEnabled;
    } else if (notification.sourceType === SourceTypes.Online) {
      this.state.countStatus.online = notification.sourceTypeEnabled;
    } else if (notification.sourceType === SourceTypes.WalkUp) {
      this.state.countStatus.walkup = notification.sourceTypeEnabled;
    }
    this.getProductionRate(); //call store production endpoint to get latest values
  };

  setPrepWindowAndProduction = () => {
    if (this.productionRateList.length > 0) {
      const { prepWindow, production } = CommonUtil.getCurrentPrepAndProdFromPrepProdSlot(this.productionRateList);
      this.setState({
        prepTime: prepWindow,
        productionTime: production,
      });
    } else {
      const { reduxProps: { storeInfo } } = this.props;
      const { productionRate, prepWindow } = storeInfo?.data || {};
      this.setState({
        prepTime: prepWindow,
        productionTime: productionRate,
      });
    }
  };

  getOrderTypeValue = (type, response) => {
    let dataType = "";
    if (response.data) {
      if (type === "sourceType") {
        dataType = FireboardUtils.getNotificationSourceType(
          response.data.sourceType
        );
      } else if (type === "orderType") {
        const orderId = response.orderTypeId;
        dataType = this.getOrderTypeName(orderId);
      } else if (type === "revenueCenter") {
        const revenueId = response.revenueCenterId;
        dataType = this.getRevenueCenterName(revenueId);
      }
    }
    return dataType;
  };

  getOrderTypeName = (id) => {
    const { reduxProps } = this.props;
    const { storeInfo } = reduxProps;
    const orderTypeDetails = storeInfo.data.orderTypes.find(
      (each) => each.id === id
    );
    if (orderTypeDetails) {
      return orderTypeDetails.name;
    }
    return "";
  };

  getRevenueCenterName = (id) => {
    const { reduxProps } = this.props;
    const { storeInfo } = reduxProps;
    const revenueCenterDetails = storeInfo.data.revenueCenters.find(
      (each) => each.id === id
    );
    if (revenueCenterDetails) {
      return revenueCenterDetails.name;
    }
    return "";
  };

  getPopup = (type, heading, message, callback) => {
    const popup =
      type === "spinner"
        ? getPopupConfig("spinner")
        : getPopupConfig("error", () => {
          callback && callback();
          this.setState({ popup: undefined });
        });
    if (heading) {
      popup.heading = heading;
    }
    if (message) {
      popup.message = message;
    }
    this.setState({ popup });
  };

  removeNewTag = (itemData) => {
    const { reduxProps, dispatchUpdateNotification } = this.props;
    const { notifications } = reduxProps;
    const newNotifications = notifications.map((n) => {
      if (n.notificationId === itemData.id) {
        return { ...n, isNew: false };
      }
      return { ...n };
    });
    dispatchUpdateNotification(newNotifications);
    this.notificationTimeout && clearTimeout(this.notificationTimeout);
    this.notificationTimestamp = new Date().getTime();
  };

  getAllChecks = (callback) => {
    const {
      reduxProps: { storeInfo },
    } = this.props;
    const { id: storeId } = storeInfo.data;
    DBManager.getStoreChecks(storeId, (error, response) => {
      if (error) {
        EventEmitter.addLogs(
          'syncLogs',
          LogLevelEnum.ERROR,
          "Get store checks errored out"
        );
        const errorMsg = error.response
          ? error.response.data
          : error.message;
        this.getPopup("error", null, errorMsg);
      } else {
        // clearTimeout(this.syncTimeout);
        response.forEach((check) => {
          this.checks.set(check.id, CommonUtil.parseCheckFromRedis(check));
        });
        EventEmitter.addLogs(
          'syncLogs',
          LogLevelEnum.INFO,
          `Response from get store checks.`
        );
        callback && callback();
        this.setState(
          {
            isFetching: false,
          },
          () => {
            this.toggleSelection(true);
          }
        );
      }
    });
  };

  getNotifications = (callback) => {
    const {
      reduxProps: { storeInfo },
    } = this.props;
    const { id: storeId } = storeInfo.data;
    DBManager.getStoreNotifications(storeId, callback);
  };

  onOpenSearchBox = () => {
    this.setState({ showSearchBox: true });
  };

  resetFilterCalendar = () => {
    this.showFutureOrders = false;
    this.setState({
      // orderStatusType: InProgressOrderStatus,
      // orderType: ALLOPTION,
      selectedDate: null
    }, () => this.toggleSelection())
  }

  onSearchReset = () => {
    this.setState({ value: "", showSearchBox: false }, () =>
      this.renderFilteredChecks("")
    );
  };

  searchChecks = () => {
    const { value } = this.state;
    this.renderFilteredChecks(value);
  };

  filterByOrderTypes = () => {
    const { orderType } = this.state;
    const { reduxProps } = this.props;
    const { storeInfo } = reduxProps;
    let allCheckList = [];
    //No filter is selected or 'All' option is selected
    if (orderType === null ||
      (Array.isArray(orderType) && orderType.length === 0) ||
      (Array.isArray(orderType) && orderType.length === 1 && orderType[0].value === 'All')
    ) {
      allCheckList = CommonUtil.getChecksList(
        this.checks,
        'All',
        storeInfo,
        this.activeCheckFilter,
        this.sensorsMap,
      );
      const filters = {
        data: {
          orderTypes: this.checkOrderTypes,
          sourceTypes: this.checkSourceTypes,
          revenueTypes: this.checkRevenueTypes,
          sensorGroupTypes: this.checkSensorGroupTypes,
          activeCheckFilter: this.activeCheckFilter,
        }
      };
      allCheckList = CommonUtil.getAllSelectedChecks(allCheckList, filters, storeInfo, this.sensorsMap);
    } else {
      orderType.forEach(eachType => {
        const checkArr = CommonUtil.getChecksList(
          this.checks,
          eachType.value,
          storeInfo,
          this.activeCheckFilter,
          this.sensorsMap,
        );
        if (Array.isArray(checkArr)) {
          allCheckList = [...allCheckList, ...checkArr];
        }
      });
    }

    //remove all duplicate checks and return an array of filtered checks
    return Array.from(new Map(allCheckList.map(item => [item.id, item])).values());
  };

  filterByOrderStatus = checkList => {
    const { orderType, orderStatusType } = this.state;
    let filteredChecksList = [];
    //no status filter is selected or All option is selected
    if (orderStatusType === null ||
      (Array.isArray(orderStatusType) && orderStatusType.length === 0) ||
      (Array.isArray(orderStatusType) && orderStatusType.length === 1 && orderStatusType[0].value === 'All')) {
      filteredChecksList = checkList;
    } else {
      const isWalkUpIncluded = orderType.some(op => op.value === 'Walk up');
      const isCurbsideIncluded = orderType.some(op => op.value === 'Curbside');
      let checksArray = [];
      orderStatusType.forEach(eachStatus => {
        const checks = CommonUtil.getChecksBasedOnFilters(checkList, eachStatus.value, isWalkUpIncluded, isCurbsideIncluded);
        if (Array.isArray(checks)) {
          checksArray = [...checksArray, ...checks];
        }
      });
      //remove duplicate checks
      filteredChecksList = Array.from(new Map(checksArray.map(item => [item.id, item])).values());
    }

    return filteredChecksList;
  };

  toggleSelection = (disableScroll, callback) => {
    const { value, fbVenueMode, selectedVenueStore } = this.state;
    const checkList = this.filterByOrderTypes();
    let filteredChecksList = this.filterByOrderStatus(checkList);

    //if fbVenueMode is ON - filter checks of selected store
    if (fbVenueMode && selectedVenueStore && selectedVenueStore?.value) {
      filteredChecksList = filteredChecksList.filter(eachCheck => eachCheck.storeId === selectedVenueStore.value);
    }

    if (this.state.currentView === 'layout') {
      this.setShapeChecks(filteredChecksList);
      return;
    }

    this.filteredCheckItems = filteredChecksList;
    this.renderFilteredChecks(value);
    this.setState(
      {
        isFetching: false,
      },
      () => {
        if (disableScroll) {
          callback && callback();
          return;
        }
        // this.scrollToSection(0);
      }
    );
  };

  renderFilteredChecks = (value) => {
    const { selectedItem, managerMode, currentMode } = this.state;
    let list = this.filteredCheckItems;
    if (!managerMode && this.showFutureOrders) {
      list = this.futureCheckItems;
    }

    //if current mode is "voucherMode" then filter checks which has the voucher(s)
    if (currentMode === modeEnums.VOUCHER) {
      list = list.filter(check => check.vouchers && Array.isArray(check.vouchers) && check.vouchers.length > 0);
    }

    const newFilteredChecklist =
      list && list.filter((check) => {
        if (
          (check.phoneNumber &&
            check.phoneNumber.toLowerCase().includes(value.trim())) ||
          (check.checkNumber &&
            check.checkNumber.toLowerCase().includes(value.trim())) ||
          (check.checkInNote &&
            check.checkInNote
              .toLowerCase()
              .includes(value && value.toLowerCase().trim())) ||
          (check.stationNumber &&
            check.stationNumber
              .toLowerCase()
              .includes(value && value.toLowerCase().trim())) ||
          (check.name &&
            check.name
              .toLowerCase()
              .includes(value && value.toLowerCase().trim()))
        ) {
          return true;
        }
        return false;
      });
    const checksSortedByOpenDate = this.sortArrayByKey(newFilteredChecklist, 'dueTime');

    //If any check is selected
    if (selectedItem && Object.keys(selectedItem).length !== 0 && selectedItem.constructor === Object) {
      const selectedCheck = newFilteredChecklist.find(check => check.id === selectedItem.id);
      if (selectedCheck) {
        const formattedCheck = this.getFormattedCheck(selectedCheck);
        this.setSelectedCheck({ ...formattedCheck, rowIndex: selectedItem.rowIndex });
      }
    }

    this.setState({
      filteredChecklist: checksSortedByOpenDate,
    });
  };

  retry = (error, callback) => {
    const popup = getPopupConfig('error', () => {
      this.setState({ popup: undefined });
    });
    popup.message = error;
    popup.buttons = [
      {
        text: constants.cancelText,
        onClick: () => {
          this.setState({ popup: undefined });
        },
      },
      {
        text: constants.retry,
        onClick: () => {
          this.setState({ popup: undefined });
          callback && callback();
        },
      },
    ];
    this.setState({ popup });
  };

  setSelectedCheck = (item) => {
    let items = item && item.items;
    let pendingCheckItems = [];
    const isPOSOrder =
      CommonUtil.getOrderTypeFromSourceType(item.sourceType) ===
      constants.orderType_POS;

    const check = this.checks.get(item.id);
    const { context } = this.props;
    const { acknowledgeCheck } = context;
    acknowledgeCheck && acknowledgeCheck(check?.checkHeaderId);
    // const check = posCheck;

    if (isPOSOrder) {
      items = FireboardUtils.updatePOSItems(item);
      const pendingItems = MenuUTIL.getPendingItemsFromCheck(item);
      pendingCheckItems = FireboardUtils.updatePendingPOSItems(pendingItems, item);
    }

    const selectedItem = item;
    const { filteredChecklist } = this.state;
    this.checks.forEach((check, checkHeaderId) => {
      const selectedCheck = this.checks.get(item.id);
      if (selectedCheck && checkHeaderId === selectedCheck.checkHeaderId) {
        this.checks.set(checkHeaderId, {
          ...check,
          isNew: false,
          paidAmountChanged: false,
          deliverToChanged: false,
        });
      }
    });
    let newFilteredChecklist = [...filteredChecklist];
    if (item.isNew || item.paidAmountChanged || item.deliverToChanged) {
      newFilteredChecklist = filteredChecklist.map((check) => {
        const selectedCheck = this.checks.get(item.id);
        if (selectedCheck && check.checkHeaderId === selectedCheck.checkHeaderId) {
          return {
            ...check,
            isNew: false,
            paidAmountChanged: false,
            deliverToChanged: false,
          };
        }
        return { ...check };
      });
    }
    this.notificationTimeout && clearTimeout(this.notificationTimeout);
    this.notificationTimestamp = new Date().getTime();
    this.setState({
      items,
      pendingCheckItems,
      selectedItem,
      filteredChecklist: newFilteredChecklist,
    });
  };

  sendPendingItems = () => {
    const { pendingCheckItems, selectedItem } = this.state;
    const { reduxProps } = this.props;
    const { storeInfo, login, deviceApi, deviceApiData } = reduxProps;
    const { deviceId } = deviceApi?.data || deviceApiData || {};
    const { id: employeeId } = login?.data || {};
    if (pendingCheckItems) {
      const checkValues = Object.values(pendingCheckItems);
      if (checkValues && checkValues.length > 0) {
        checkValues.forEach(eachSeat => {
          if (eachSeat && eachSeat.length > 0) {
            this.getPopup("spinner", constants.sendPendingItems, null);
            let allItems = [];
            eachSeat.forEach(eachItem => {
              allItems.push({
                checkOrderItemId: eachItem.id,
                orderSendMode: eachItem.orderSendMode,
              });
            });

            const request = {
              storeId: storeInfo.data.id,
              employeeId: employeeId || null,
              deviceId: deviceId,
              checkHeaderId: selectedItem?.checkHeaderId || selectedItem?.id,
              employeeCard: null,
              items: allItems,
            }
            API.firePendingItems(request)
              .then((res) => {
                this.dismissPopup();
                FireboardUtils.addNetworkLogs(res);
              })
              .catch((error) => this.handleErrorPopup(error));
          }
        })
      }
    }
  }

  getFutureOrdersList = () => {
    const { reduxProps } = this.props;
    const { storeInfo } = reduxProps;
    const currentDate = new Date().setHours(0, 0, 0, 0);
    const { latitude, longitude } = UTILLib.location;
    this.getPopup("spinner", constants.getFutureOrderSummary, null);
    API.getFutureOrdersList({
      latitude,
      longitude,
      storeId: storeInfo.data.id,
    })
      .then((res) => {
        this.setState({
          popup: undefined,
          futureOrdersList: res.data,
          selectedItem: {},
          items: [],
          selectedDate: currentDate,
        }, () => this.onDateChange(currentDate));
        FireboardUtils.addNetworkLogs(res);
      })
      .catch((error) => this.handleErrorPopup(error));
  };

  headerPress = (type, value) => {
    switch (type) {
      case NOTIFICATION: {
        clearInterval(this.snoozeTimeInterval);
        this.setState(
          (prevState) => ({
            selectedItem: {},
            items: [],
            showNotifications: !prevState.showNotifications,
            notificationControlEnabled: false,
            snoozeEnabled: false,
            cashPayFlag: false,
            customTextToPay: false,
            isPayNow: false,
            isCheckInRequest: false,
            filteredChecklist: [],
          }),
          () => {
            const { showNotifications } = this.state;
            if (!showNotifications) {
              this.toggleSelection();
            }
          }
        );
        break;
      }
      default: {
        console.debug("unhandled iconPress", type, value);
        break;
      }
    }
  };

  onOrderTypeChange = (types) => {
    //check whether 'All' option is selected or not
    const isAllOption = Array.isArray(types) && types.filter(option => option.value === 'All').length > 0;
    let selectedTypes = [...types];
    if (isAllOption && types.length > 1) {
      //If 'All' is already selected and user select other types
      if (types[0].value === 'All') {
        selectedTypes = types.filter(option => option.value !== 'All'); //remove 'All' option & keep other options
      } else {
        selectedTypes = types.filter(option => option.value === 'All'); //remove other options & keep 'All' option
      }
    }

    //if currentView is 'layout' & source type filter is by sensorGroup -> then allow only single selection
    if (this.state.currentView === 'layout' && this.isSensorGroupFilterEnabled()) {
      selectedTypes = selectedTypes.length > 1 ? [selectedTypes[selectedTypes.length - 1]] : [...selectedTypes];
    }

    this.setState(
      {
        orderType: selectedTypes,
        selectedItem: {},
        items: [],
        showNotifications: false,
        customTextToPay: false,
        filteredChecklist: [],
      },
      () => this.handleOrderTypeChange()
    );

    //persist selected order types
    const { disptachUpdateFbCheckFilters } = this.props;
    let typeName = '';
    if (this.activeCheckFilter === "sourceType") {
      typeName = 'odOrderTypeFilters';
    } else if (this.activeCheckFilter === "orderType") {
      typeName = 'posOrderTypeFilter';
    } else if (this.activeCheckFilter === "revenueCenter") {
      typeName = 'revenueCenterTypeFilter';
    } else if (this.activeCheckFilter === "sensorGroup") {
      typeName = 'sensorGroupTypeFilter';
    }
    disptachUpdateFbCheckFilters({ [typeName]: selectedTypes });
  };

  handleOrderTypeChange = () => {
    if (this.state.currentView === 'layout') {
      this.onChangeSensorGroup();
    } else {
      this.toggleSelection();
    }
  };

  onOrderStatusChange = (status) => {
    //check whether 'All' option is selected or not
    const isAllOption = Array.isArray(status) && status.filter(option => option.value === "All").length > 0;
    let selectedStatus = [...status];
    if (isAllOption && status.length > 1) {
      //if 'All' is already selected and user select other status
      if (status[0].value === 'All') {
        selectedStatus = status.filter(option => option.value !== 'All'); //remove 'All' option & keep other options
      } else {
        selectedStatus = status.filter(option => option.value === 'All'); //remove other options & keep 'All' option
      }
    }

    this.setState(
      {
        orderStatusType: selectedStatus,
        selectedItem: {},
        items: [],
        showNotifications: false,
        customTextToPay: false,
        filteredChecklist: [],
      },
      () => {
        this.toggleSelection();
      }
    );

    //persist selected order status
    const { disptachUpdateFbCheckFilters } = this.props;
    disptachUpdateFbCheckFilters({ orderStatusFilters: selectedStatus });
  };

  setOrderStatusFilter = () => {
    const { reduxProps } = this.props;
    const { fbCheckFilters } = reduxProps;
    const { orderStatusFilters } = fbCheckFilters || {};
    if (orderStatusFilters && Array.isArray(orderStatusFilters) && orderStatusFilters.length > 0) {
      this.setState({ orderStatusType: orderStatusFilters });
    }
  };

  onHandleSend = (msg, customSmsObj) => {
    const { selectedItem, selectedCountry, isCustomSmsType } = this.state;
    const { reduxProps } = this.props;
    const { storeInfo, deviceApi, currencyInfo: { iso2 } } = reduxProps;
    const { deviceId } = deviceApi?.data;
    const { tickets, unpaidAmount } = selectedItem;
    const preauthTicket = tickets && tickets.find(ticket => ticket.ticketStatusId === 0 && ticket.preAuth && unpaidAmount > 0);
    const popup = getPopupConfig("error");
    popup.heading = constants.confirmationMessage;
    const phoneNumberForSMS = FireboardUtils.formattedPhoneNumber(selectedItem.selectedCheckDetails.phoneNumber || "", iso2);
    popup.message = constants.sendSmsPopupMsg;
    popup.buttons = [
      {
        text: constants.no,
        onClick: () => {
          this.setState({ popup: undefined });
        },
      },
      {
        text: constants.yes,
        onClick: () => {
          this.getPopup("spinner", constants.smdSendLoaderHeading, null);
          const { latitude, longitude } = UTILLib.location;
          let payload = {
            latitude,
            longitude,
            deviceId: deviceId,
            storeId: storeInfo.data.id,
            phoneNumber: selectedItem.selectedCheckDetails.phoneNumber || null,
            countryCode: selectedCountry.dialCode.split('+')[1],
            message: msg,
            checkHeaderId: selectedItem?.checkHeaderId || selectedItem?.id,
          };
          if (isCustomSmsType) {
            payload = {
              ...payload,
              custom: true,
              templateId: customSmsObj?.id,
            };
          }
          if (this.seatId) {
            payload['seatId'] = this.seatId;
            this.seatId = null;
          }
          if (preauthTicket) {
            payload['checkTicketId'] = preauthTicket?.id || null;
          }
          API.fireboardSendSMS(payload)
            .then((resp) => {
              console.debug("responsee from sms api", resp);
              this.dismissPopup();
              FireboardUtils.addNetworkLogs(resp);
            })
            .catch((error) => {
              console.debug("error from sms api", error, error.response);
              this.handleErrorPopup(error);
            });
        },
      },
    ];
    this.setState({ popup });
  };

  generateQR = (item) => {
    this.setState({
      popup: {
        type: POPUPS_ENUMS.GENERATE_QR,
        meta: item,
      },
    });
  };

  getEllapsedTime = (check) => {
    if (!check?.elapsedTime)
      return "- -";
    const time = Math.abs(check.elapsedTime);
    const convertedTimeInSeconds = parseInt(time / TimeConstants.SECOND);
    if (convertedTimeInSeconds < 60)
      return `${UTIL.round(convertedTimeInSeconds, 0)}s`;
    const convertedTimeInMinutes = convertedTimeInSeconds / 60;
    if (convertedTimeInMinutes < 120)
      return `${UTIL.round(convertedTimeInMinutes, 0)}m`;

    return "2h+";
  };

  getCheckStatus = (check) => {
    const { status } = FireboardUtils.getOrderNameFromOrderId(check);
    return status;
  };

  getStatusColor = (check) => {
    const { color } = FireboardUtils.getOrderNameFromOrderId(check);
    return color;
  };

  getRelatedNotificationsForCheck = (check, notifications) => {
    const relatedNotifications = notifications.filter(
      n => n.data.checkHeaderId === check.id,
    );
    return relatedNotifications;
  };

  getLocationElapsedTime = (refTime) => {
    const locationElapsedTimeInMS = FireboardUtils.getElapsedTimeInMilliseconds(refTime);
    const locationElapsedTimeInMin = locationElapsedTimeInMS / TimeConstants.MINUTE;
    const locationElapsedTimeInMinTxt = FireboardUtils.convertElapsedTimeToDisplayTime(locationElapsedTimeInMS);
    let locationRefButtonColor = 'red';
    if (locationElapsedTimeInMin <= 3)
      locationRefButtonColor = 'green';
    else if (locationElapsedTimeInMin > 3 && locationElapsedTimeInMin <= 6)
      locationRefButtonColor = 'orange';
    else if (locationElapsedTimeInMin > 6)
      locationRefButtonColor = 'red';
    return { locationElapsedTimeInMinTxt, locationRefButtonColor };
  };

  getFormattedCheck = check => {
    const { reduxProps: { currencyInfo } } = this.props;
    const { iso2 } = currencyInfo || {};
    const { selectedItem, venueName } = this.state;
    const notificationsToBeDisplayed = this.getManagerNotifications();
    const relatedNotifications = this.getRelatedNotificationsForCheck(check, notificationsToBeDisplayed);
    const { paidIcon, preAuthIcon } = FireboardUtils.getPaidStatusIcon(check, this.currency);
    const [order0] = check?.orders || [];
    const slot = this.storeCubbySlotsMap.has(order0?.storeCubbySlotId) ? this.storeCubbySlotsMap.get(order0?.storeCubbySlotId) : {};
    const slotName = slot?.name || '';
    const { locationElapsedTimeInMinTxt, locationRefButtonColor } = this.getLocationElapsedTime(order0?.lastLocationUpdateDate);
    return {
      relatedNotifications: relatedNotifications,
      phoneNumber: check.phoneNumber
        ? FireboardUtils.formattedPhoneNumber(check.phoneNumber, iso2)
        : "- -",
      checkNumber: `[${check.checkNumber}]` || "- -",
      number: check.number,
      checkNumberForSorting: FireboardUtils.addPrefixWithZero(check.number || '', 10),
      checkInTime: FireboardUtils.getCheckInTime(check),
      checkInTimeForSorting: new Date(check.checkInDate).getTime(),
      dueTime: FireboardUtils.getTimeInHrsMins(check.dueTimeDisplay),
      dueTimeForSorting: new Date(check.dueTimeDisplay).getTime(),
      deliverTo: FireboardUtils.getDeliverTo(check),
      sourceType: check.sourceType,
      paidIcon: paidIcon,
      preAuthIcon: preAuthIcon,
      paid: preAuthIcon || paidIcon,
      ellapsedTime: this.getEllapsedTime(check),
      ellapsedTimeColor: (!check.elapsedTime || check.elapsedTime < 0) ? 'green' : 'red',
      ellapsedTimeForSorting: check.elapsedTime,
      status: this.getCheckStatus(check),
      color: this.getStatusColor(check),
      isNew: check.isNew,
      items: check.items,
      id: check.id,
      selectedCheckDetails: check,
      orderStatusId: check.orderStatusId,
      unpaidAmount: check.unpaidAmount,
      paidAmount: check.paidAmount,
      pickupDate: check.pickupDate,
      checkHeaderId: check.checkHeaderId,
      referenceId: check.referenceId,
      guestName: check.guestName,
      totalAmount: check.totalAmount,
      onHandleCheckActions: this.onHandleCheckActions,
      orders: check.orders,
      seats: check.seats,
      tickets: check.tickets,
      stationId: check.stationId,
      open: check.open,
      paidAmountChanged: check?.paidAmountChanged || false,
      deliverToChanged: check?.deliverToChanged || false,
      rowSelected: check.id === selectedItem.id,
      highlightRow: relatedNotifications && relatedNotifications.length > 0,
      stationName: check.stationName,
      stationNumber: check.stationNumber,
      businessDate: check.businessDate,
      selectedForBatchPreauth: check.selectedForBatchPreauth || false,
      vouchers: check.vouchers,
      revenueCenterId: check.revenueCenterId,
      orderTypeId: check.orderTypeId,
      checkName: check.name,
      tabName: check.tabName,
      slotName: slotName,
      closeDate: check.closeDate,
      locationUpdateElapsedTime: locationElapsedTimeInMinTxt,
      locationRefreshButtonColor: locationRefButtonColor,
      void: check.void,
      employeeFirstName: check.employeeFirstName,
      employeeLastName: check.employeeLastName,
      checkStoreId: check.storeId,
      checkStoreName: check.storeName,
      venueName: venueName,
      storeId: check.storeId,
      tab: check.tab,
      storeName: check.storeName,
    };
  };

  get checksRowData() {
    const { filteredChecklist } = this.state;
    const rowData =
      Array.isArray(filteredChecklist) &&
      filteredChecklist.length &&
      filteredChecklist.map((check) => this.getFormattedCheck(check));
    return rowData ? rowData : [];
  }

  getTime = (notification) =>
    notification.notificationTimes !== null &&
      notification.notificationTimes !== undefined
      ? FireboardUtils.getTimeInHrsMins(notification.notificationTimes)
      : "--";

  sortNotifications = (notifications) => {
    const sortKey = "notificationId";
    return notifications.sort((n1, n2) => n2[sortKey] - n1[sortKey]);
  };

  getSelectedNotificationTypeIds = () => {
    const { reduxProps } = this.props;
    const { storeInfo } = reduxProps;
    const { notificationTypes = [] } = storeInfo.data || {};
    const { notificationTypes: selectedNotifications } = this.state;
    const nTypeIds = [];
    selectedNotifications.forEach(sn => {
      const n = notificationTypes.find(nt => nt.name === sn);
      if (n) nTypeIds.push(n.id);
    });

    /** These 3 notification type filter should always be enabled
     * ["MDM Policy Updated", "Device Notification", "Channel Status Update"]
     */
    const enabledNotificationIds = [16, 19, 20];
    return Array.from(new Set(nTypeIds.concat(enabledNotificationIds)));
  };

  getNotificationsToBeDisplayed = () => {
    const { reduxProps } = this.props;
    const { managerMode, notificationTypes } = this.state;
    const { notifications } = reduxProps;
    let notificationsToBeDisplayed = notifications;
    const selectedNotifications = notificationTypes || [];
    const activeNotificationFilter = this.activeCheckFilter;
    if (managerMode) {
      return notifications.filter(n => n.notificationTypeId === 14 || n.notificationTypeId === 15);
    }
    if (selectedNotifications.length > 0) {
      const selectedIds = this.getSelectedNotificationTypeIds();
      notificationsToBeDisplayed = notifications.filter(
        notification => selectedIds.includes(notification.notificationTypeId) &&
          !notification.dismissed &&
          notification.notificationTypeId !== 15,
      );
      if (selectedIds.includes(9)) {
        const nOrderTypes = this.getNotificationOrderTypes();
        notificationsToBeDisplayed = notificationsToBeDisplayed.filter(r => {
          const sourceType = this.getOrderTypeValue(activeNotificationFilter, r);
          const hasOrderType = sourceType === constants.orderType_POS
            ? (nOrderTypes.includes(constants.orderType_POS) || nOrderTypes.includes(constants.orderType_Table) || nOrderTypes.includes(constants.orderType_Tab))
            : nOrderTypes.includes(sourceType);
          return (
            (nOrderTypes.length === 0 || hasOrderType) &&
            r.notificationTypeId !== NotificationType.SURVEY_POSTED &&
            r.notificationTypeId !== NotificationType.SERVER_APP_PRINTER &&
            !r.isDismissed
          );
        });
      }
    } else {
      notificationsToBeDisplayed = notifications.filter(
        n => !n.isDismissed && n.notificationTypeId !== 15,
      );
    }
    notificationsToBeDisplayed = notificationsToBeDisplayed.filter(n => n.enabled);
    return notificationsToBeDisplayed;
  }

  get notificationsData() {
    const notificationsToBeDisplayed = this.getNotificationsToBeDisplayed();
    const sortedNotifications = this.sortNotifications(
      notificationsToBeDisplayed
    );
    const { managerMode } = this.state;

    const rowData =
      Array.isArray(sortedNotifications) &&
      sortedNotifications.length &&
      sortedNotifications.map((notification) => {
        return {
          sourceType:
            notification && notification.data && notification.data.sourceType,
          isNew: notification.isNew,
          time: this.getTime(notification),
          message: notification.note,
          ack: true,
          dismiss: true,
          goAndDismiss: true,
          notificationGoAndDismiss: this.notificationGoAndDismiss,
          dismissNotification: this.dismissNotification,
          ackNotification: this.ackNotification,
          acknowledgeIdCheck: this.acknowledgeIdCheck,
          // acknowledgeOverServe: this.acknowledgeOverServe,
          notification: notification,
          goToCheck: this.goToCheck,
          managerMode,
        };
      });
    return rowData;
  }

  joinCheck = item => {
    const { sensorData } = this.state;
    const { reduxProps } = this.props;
    const { storeInfo } = reduxProps;
    if (sensorData && sensorData.externalId) {
      this.setState({
        popup: {
          type: POPUPS_ENUMS.GENERATE_QR_JOIN_CHECK,
          meta: item,
          sensorData: sensorData,
        },
      });
    } else {
      API.sensorCode({
        storeId: storeInfo.data.id,
        stationId: item.stationId,
      })
        .then((resp) => {
          console.debug("responsee from joinCheck api", resp);
          this.setState({
            sensorData: resp.data,
            popup: {
              type: POPUPS_ENUMS.GENERATE_QR_JOIN_CHECK,
              meta: item,
              sensorData: resp.data,
            },
          });
          FireboardUtils.addNetworkLogs(resp);
        })
        .catch((error) => {
          console.debug("error from joinCheck api", error, error.response);
          this.handleErrorPopup(error);
        });
    }
  }

  updateOrderStatus = (item, type) => {
    let delivery = false;
    let deliveryVendorName = '';
    let held = false;
    if (item.orders && item.orders.length > 0) {
      delivery = item.orders[0].delivery || false;
      deliveryVendorName = item.orders[0].deliveryVendorName || '';
      held = item.orders[0].held || false;
    }
    let orderStatusId;
    if (type === "done") {
      // TODO: add enums
      orderStatusId = 5;
      this.dispatchOrderStatus(item.selectedCheckDetails, orderStatusId);
    } else if (type === "cancel") {
      const popup = getPopupConfig("success");
      popup.heading = constants.orderCancellation;
      popup.message = held ? delivery ? 'This action will cancel the order immediately. The order delivery will also be canceled at ' + deliveryVendorName + '. If applicable, the order will not be sent to the POS. This action cannot be reversed. Do you want to continue?' : constants.cancelHeldOrderMsg : delivery ? 'Are you sure you want to cancel the order ? This action will ONLY cancel from the Fireboard and ' + deliveryVendorName + '. This action will NOT cancel from the POS and NOT process a refund.' : constants.cancelCheckHeadingAlt;
      popup.buttons = [
        {
          text: constants.no,
          onClick: () => {
            this.setState({ popup: undefined });
          },
        },
        {
          text: constants.yes,
          onClick: () => {
            this.cancelOrder(item.selectedCheckDetails);
          },
        },
      ];
      this.setState({ popup });
    } else if (type === "moveToInprogress") {
      const popup = getPopupConfig("error");
      popup.heading = constants.futureToIPHeader;
      popup.message = held ? constants.moveHeldOrderMsg : constants.futureToIPMessage;
      popup.buttons = [
        {
          text: constants.noCaps,
          onClick: () => this.setState({ popup: undefined }),
        },
        {
          text: constants.yesCaps,
          onClick: () => {
            orderStatusId = 1;
            this.dispatchOrderStatus(item.selectedCheckDetails, orderStatusId);
          },
        },
      ];
      this.setState({ popup });
    }
  };

  cancelOrder = (item) => {
    const orderStatusId = 8;
    this.dispatchOrderStatus(item, orderStatusId, true);
  };

  dispatchOrderStatus = (item, orderStatusId, isCancel) => {
    const { reduxProps } = this.props;
    const { storeInfo, deviceApi } = reduxProps;
    const { deviceId } = deviceApi?.data;
    this.getPopup("spinner", constants.updateOrderLoading, null);
    let delivery = false;
    let deliveryVendorName = '';
    if (item.orders && item.orders.length > 0) {
      delivery = item.orders[0].delivery || false;
      deliveryVendorName = item.orders[0].deliveryVendorName || '';
    }
    API.orderStatusUpdate({
      storeId: storeInfo.data.id,
      deviceId: deviceId,
      checkHeaderId: item.id,
      orderStatusId,
    })
      .then((response) => {
        console.debug("response from orderStatusUpdate", response);
        this.checks.set(response.data.id, CommonUtil.parseCheckFromRedis(response.data));

        //future order- check need to be remove when status get changed 
        if (this.showFutureOrders) {
          const newfutureCheckItems = this.futureCheckItems.filter(it => it.checkHeaderId !== response.data.id);
          this.futureCheckItems = newfutureCheckItems;
        }
        this.toggleSelection(true);
        if (isCancel) {
          const popup = getPopupConfig("success", () => {
            this.closePopup();
          });
          popup.heading = constants.cancelSuccess;
          popup.message = delivery ? 'Order has been cancelled from the Fireboard and ' + deliveryVendorName + '. Please make sure to cancel it on the POS and process a refund from the portal (if applicable)' : constants.cancelSuccessMsg;
          this.setState({ popup });
        } else {
          this.closePopup();
        }
        FireboardUtils.addNetworkLogs(response);
      })
      .catch((error) => {
        this.handleErrorPopup(error);
      });
  };

  printCheck = (item) => {
    const { dispatchPrintAction, reduxProps } = this.props;
    const { storeInfo, deviceApi, login } = reduxProps;
    const { deviceId } = deviceApi?.data;
    const { id } = item;
    dispatchPrintAction({
      storeId: storeInfo.data.id,
      deviceId: deviceId,
      employeeId: 0,
      checkHeaderId: id,
      seatIds: [],
      employeeCard: reduxProps.employee ? reduxProps.employee.loginId : null,
    });
  };

  onHandleSms = () => {
    this.setState({
      popup: {
        type: POPUPS_ENUMS.SMS,
      },
    });
  };

  onHandleTextToPay = (item, fromFooter) => {
    this.setState({ popup: { type: "textToPay", meta: item }, fromFooter, });
  };

  textToCheckIn = (item, fromFooter) => {
    this.setState({ popup: { type: "checkIn", meta: item }, fromFooter, });
  };

  onHandleCheckActions = () => {
    this.setState({ popup: { type: "check-options" }, });
  };

  markItemAPaid = (item) => {
    const { reduxProps } = this.props;
    const { storeInfo, deviceApi } = reduxProps;
    const { deviceId } = deviceApi?.data;
    this.getPopup("spinner", constants.updateOrderLoading, null);
    API.orderStatusPaid({
      storeId: storeInfo.data.id,
      deviceId: deviceId,
      checkHeaderId: item.id,
    })
      .then((response) => {
        console.debug("response from orderStatusPaid", response);
        this.checks.set(response.data.id, CommonUtil.parseCheckFromRedis(response.data));
        this.toggleSelection(true);
        this.setState({ popup: undefined });
        FireboardUtils.addNetworkLogs(response);
      })
      .catch((error) => {
        this.handleErrorPopup(error);
      });
  };

  notifyOrderStatus = (type) => {
    const { selectedItem, selectedCountry } = this.state;
    const { reduxProps } = this.props;
    const { storeInfo, deviceApi } = reduxProps;
    const { deviceId } = deviceApi?.data;
    this.getPopup("spinner", type === 'orderBeingPrepared' ? constants.notifyOrderBeingPrepared : constants.notifyOrderReady, null);
    let templateId;
    if (type === 'orderBeingPrepared') {
      templateId = this.notifyOrderPrepared.id;
    } else {
      templateId = this.notifyOrderReady.id;
    }
    const { latitude, longitude } = UTILLib.location;
    let payload = {
      latitude,
      longitude,
      deviceId: deviceId,
      storeId: storeInfo.data.id,
      phoneNumber: selectedItem.selectedCheckDetails.phoneNumber || "",
      countryCode: selectedCountry.dialCode.split('+')[1],
      custom: true,
      templateId: templateId,
      checkHeaderId: selectedItem?.checkHeaderId || selectedItem?.id,
    };
    API.fireboardSendSMS(payload)
      .then((resp) => {
        console.debug("responsee from notify order status api", resp);
        this.dismissPopup();
        FireboardUtils.addNetworkLogs(resp);
      })
      .catch((error) => {
        console.debug("error from notify order status api", error, error.response);
        this.handleErrorPopup(error);
      });
  };

  onFooterIconPress = (type, fromFooter) => {
    switch (type) {
      case "sort":
      case "payNow":
      case "settings":
      case "channels":
      case "about":
      case "diagnostics":
      case "outOfStock":
      case "sensors":
      case "findVoucher":
      case "networkLogs": {
        this.setState({ popup: { type: type }, selectedItem: {}, });
        break;
      }
      case "managerLogin": {
        //when you click "launch external app" menu - it will prompt to login
        //if you just simply closed the login popup, then there is possibilities that flag has been not reset.
        this.allowExternalAppLaunch = false; //reset flag of external app launch
        this.setState({ popup: { type: type }, selectedItem: {}, });
        break;
      }
      case "textToPay": {
        this.setState({ popup: { type: "textToPay" }, selectedItem: {}, fromFooter: true });
        break;
      }
      case "checkIn": {
        this.setState({ popup: { type: "checkIn" }, fromFooter: true, selectedItem: {}, });
        break;
      }
      case "pairWatch": {
        this.setState({ popup: { type: "pairWatch" }, selectedItem: {}, loginInfo: null });
        break;
      }
      case "marketplaceStatus": {
        this.setState({ popup: { type: "marketplaceStatus" }, selectedItem: {} });
        break;
      }
      case "tableMerge": {
        const { history } = this.props;
        history && history.push('/tableMerge');
        break;
      }
      case "employeeAssignment": {
        const { history } = this.props;
        let routeName = '/employeeAssignment';
        const { reduxProps: { storeInfo } } = this.props;
        const { serverAppFeatures } = storeInfo?.data || {};
        const { useSectionForEmployeeAssignment } = serverAppFeatures || {};
        if (useSectionForEmployeeAssignment) {
          routeName = '/employeeSectionAssignment';
        }
        history && history.push(routeName);
        break;
      }
      case "tileView": {
        const { currentView } = this.state;
        this.toggleView(currentView === 'card' ? 'list' : 'card');
        break;
      }
      case "layoutView": {
        const { shapes } = this.state;
        if (shapes.size || this.storeLayoutBySensorGroup || this.isSensorGroupFilterEnabled()) {
          this.toggleView('layout');
        } else {
          this.getPopup('error', null, 'No layout found for this store.');
        }
        break;
      }
      case 'sensorGroups': {
        this.getSensorGroupsFromStoreInfo();
        break;
      }
      case 'redeemOnlyVoucher': {
        if (window.ReactNativeWebView) {
          this.redeemOnlyVoucher = true;
          EventEmitter.scanQRCodeToRedeem('scanToRedeem');
        }
        break;
      }
      case 'productionRate': {
        this.openProductionRatePopup();
        break;
      }
      case 'launchExternalApp': {
        if (window.ReactNativeWebView) {
          //prompt employee login
          this.allowExternalAppLaunch = true;
          this.setState({ popup: { type: 'managerLogin' } });
        }
        break;
      }
      case "syncChecks": {
        this.reSync();
        break;
      }
      case "bulkTextToPay": {
        this.goToBulkTextToPay();
        break;
      }
      case 'layoutDesign': {
        const { history } = this.props;
        history && history.push('/playground');
        break;
      }
      case 'futureOrders': {
        this.showFutureOrders = true;
        this.getFutureOrdersList();
        break;
      }
      default: {
        console.warn("popup type unhandled", type);
      }
    }
  };

  sortArrayByKey = (array, key) => {
    const { sortFilter } = this.state;
    const lowToHigh = array.sort(function (a, b) {
      const first = a[key];
      const second = b[key];
      return ((first < second) ? -1 : ((first > second) ? 1 : 0));
    });
    return sortFilter ? lowToHigh.reverse() : lowToHigh;
  }

  setSortType = () => {
    const { sortFilter } = this.state;
    this.setState(
      {
        sortFilter: !sortFilter,
      },
      () => {
        const { dispatchUpdateCheckSort } = this.props;
        const { sortFilter, filteredChecklist } = this.state;
        this.sortArrayByKey(filteredChecklist, 'dueTime');
        dispatchUpdateCheckSort({ sortFilter });
      },
    );
  }

  updateSortModel = sortModel => {
    this.sortModel = sortModel;
    const { dispatchUpdateCheckSort } = this.props;
    dispatchUpdateCheckSort && dispatchUpdateCheckSort({ sortModel: sortModel });
  };

  setCounterType = (counter, callback) => {
    this.setState(
      {
        counters: counter,
      },
      () => callback && callback(),
    );
  };


  onSaveFilter = (
    activeCheckFilter,
    orderTypes,
    sourceTypes,
    revenueTypes,
    sensorGrpTypes,
    orderTypeNotifications,
    sourceTypeNotifications,
    revenueTypeNotifications,
    sensorGrpTypeNotifications,
    notificationTypesList,
    counters,
  ) => {
    const {
      dispatchUpdateStatusType,
      dispatchUpdateNotificationType,
    } = this.props;
    const storeTypesPersistPayload = {
      orderTypes,
      sourceTypes,
      revenueTypes,
      sensorGrpTypes,
      activeCheckFilter,
      notificationTypes: notificationTypesList,
      counterTypes: counters,
    }
    dispatchUpdateStatusType(storeTypesPersistPayload);
    dispatchUpdateNotificationType({
      orderType: orderTypeNotifications,
      sourceType: sourceTypeNotifications,
      revenueCenter: revenueTypeNotifications,
      sensorGrpTypes: [], //sensorGrpTypeNotifications,
      activeNotificationFilter: activeCheckFilter,
    });

    this.setNotificationType(notificationTypesList);

    this.activeCheckFilter = activeCheckFilter || 'sourceType';
    this.checkSourceTypes = sourceTypes || [];
    this.checkOrderTypes = orderTypes || [];
    this.checkRevenueTypes = revenueTypes || [];
    this.checkSensorGroupTypes = sensorGrpTypes || [];
    this.notificationSourceTypes = sourceTypeNotifications || [];
    this.notificationOrderTypes = orderTypeNotifications || [];
    this.notificationRevenueTypes = revenueTypeNotifications || [];
    this.notificationSensorGroupTypes = []; //sensorGrpTypeNotifications || [];
    if (activeCheckFilter === 'sourceType') {
      this.setOrderType(sourceTypes, this.toggleSelection);
    } else if (activeCheckFilter === 'revenueCenter') {
      this.setOrderType(revenueTypes, this.toggleSelection);
    } else if (activeCheckFilter === 'orderType') {
      this.setOrderType(orderTypes, this.toggleSelection);
    } else if (activeCheckFilter === 'sensorGroup') {
      this.setOrderType(sensorGrpTypes, this.toggleSelection);
    }
    this.setState({ popup: undefined });
  };

  getToggleType = (type) => {
    switch (type) {
      case "curbside":
        return "Curbside";
      case "online":
        return "Online";
      case "walkup":
        return "Walkup";
      default:
        return "";
    }
  };

  getSourceTypeFromOrderType = (type) => {
    switch (type) {
      case "curbside":
        return 5;
      case "online":
        return 6;
      case "callIn":
        return 8;
      case "walkup":
        return 7;
      default:
        break;
    }
  };

  invokeDisableOrder = (type) => {
    const { countStatus } = this.state;
    const { reduxProps } = this.props;
    const { storeInfo, deviceApi } = reduxProps;
    const { deviceId } = deviceApi?.data;
    this.getPopup("spinner", constants.channelChangeLoader, null);

    API.disableOrders({
      latitude: 0,
      longitude: 0,
      storeId: storeInfo.data.id,
      deviceId: deviceId,
      sourceType: this.getSourceTypeFromOrderType(type),
      enabled: !countStatus[type],
    })
      .then((response) => {
        console.debug("response from channelStatus", response);
        this.setState({ popup: { type: "channels" } });
        FireboardUtils.addNetworkLogs(response);
      })
      .catch((error) => {
        console.debug("error from disabling order", error, error.response);
        const errorMsg = error.response
          ? error.response.data.message
          : error.message;
        FireboardUtils.addNetworkLogs(error.response);
        this.retry(errorMsg, () => {
          this.invokeDisableOrder(type);
        });
      });
  };

  disableChannelUpdate = key => {
    const { reduxProps: { deviceApi, deviceApiData } } = this.props;
    const { deviceGroup } = deviceApi?.data || deviceApiData || {};
    if (deviceGroup && !FireboardUtils.isObjectBlank(deviceGroup) && !deviceGroup?.fireBoardSettings?.[key])
      return true;
    return false;
  };

  onToggleCount = (type) => {
    if (this.disableChannelUpdate('enableUpdateChannelSettings')) return;

    if (type === "prepTime" || type === "productionRate") {
      this.setState({
        popup: {
          type,
        },
      });
      return;
    }
    const { countStatus } = this.state;
    const popup = getPopupConfig("error");
    const enabled = countStatus[type];
    popup.heading = `${enabled ? "Disable" : "Enable"} ${this.getToggleType(
      type
    )} Orders`;
    if (enabled) {
      popup.message = `This will stop accepting ${type} orders. Would you like to proceed?`;
    } else {
      popup.message = `This will start accepting ${type} orders. Would you like to proceed?`;
    }
    popup.buttons = [
      {
        text: "No",
        onClick: () => this.setState({ popup: { type: "channels" } }),
      },
      {
        text: "Yes",
        onClick: () => this.invokeDisableOrder(type),
      },
    ];
    this.setState({ popup });
  };

  onUpdate = (type, value) => {
    if (this.disableChannelUpdate('enableUpdatePrepProdSettings')) return;

    const {
      reduxProps: { storeInfo },
    } = this.props;
    if (type === "prepTime") {
      this.getPopup("spinner", "Updating Preparation Time", null);
      API.updatePrepTime({ prepWindow: value, storeId: storeInfo.data.id })
        .then((res) => {
          console.info("response from updatePrepTime", res);
          this.setState({ prepTime: value, popup: { type: "channels" } });
          FireboardUtils.addNetworkLogs(res);
        })
        .catch((error) => this.handleErrorPopup(error));
    } else if (type === "productionRate") {
      this.getPopup("spinner", "Updating Production Rate", null);
      API.updateProdTime({ productionRate: value, storeId: storeInfo.data.id })
        .then((res) => {
          console.info("response from updateProdutionTime", res);
          this.setState({ productionTime: value, popup: { type: "channels" } });
          FireboardUtils.addNetworkLogs(res);
        })
        .catch((error) => this.handleErrorPopup(error));
    }
  };

  invokeVenueOrderChange = () => {
    const { venueOrder } = this.state;
    const { reduxProps } = this.props;
    const { storeInfo, deviceApi } = reduxProps;
    const { deviceId } = deviceApi?.data;
    this.getPopup("spinner", constants.venueOrderChangeLoader, null);

    API.updateVenueOrder({
      latitude: 0,
      longitude: 0,
      storeId: storeInfo.data.id,
      deviceId: deviceId,
      enableVenueOrdering: !venueOrder,
    })
      .then((response) => {
        console.debug("response from venue order", response);
        this.setState({ venueOrder: !venueOrder, popup: { type: "channels" } });
        FireboardUtils.addNetworkLogs(response);
      })
      .catch((error) => {
        console.debug("error from venue order", error, error.response);
        const errorMsg = error.response
          ? error.response.data.message
          : error.message;
        FireboardUtils.addNetworkLogs(error.response);
        this.retry(errorMsg, () => {
          this.invokeVenueOrderChange();
        });
      });
  };

  invokeFoodRunnerChange = () => {
    const { foodRunner } = this.state;
    const { reduxProps } = this.props;
    const { storeInfo, deviceApi } = reduxProps;
    const { deviceId } = deviceApi?.data;
    this.getPopup("spinner", constants.foodRunnerChangeLoader, null);

    API.updateFoodRunner({
      latitude: 0,
      longitude: 0,
      storeId: storeInfo.data.id,
      deviceId: deviceId,
      enableFoodRunner: !foodRunner,
    })
      .then((response) => {
        console.debug("response from food runner", response);
        this.setState({ foodRunner: !foodRunner, popup: { type: "channels" } });
        FireboardUtils.addNetworkLogs(response);
      })
      .catch((error) => {
        console.debug("error from food runner", error, error.response);
        const errorMsg = error.response
          ? error.response.data.message
          : error.message;
        FireboardUtils.addNetworkLogs(error.response);
        this.retry(errorMsg, () => {
          this.invokeFoodRunnerChange();
        });
      });
  };

  onToggleOrderSettings = (type) => {
    if (this.disableChannelUpdate('enableUpdateOrderSettings')) return;

    const { venueOrder, foodRunner } = this.state;
    const popup = getPopupConfig("error");
    const venueOrderEnabled = venueOrder;
    const foodRunnerEnabled = foodRunner;
    if (type === 'venueOrder') {
      if (venueOrderEnabled) {
        popup.heading = "Disable Venue Order Setting";
        popup.message = `This will disable Venue Order Setting`;
      } else {
        popup.heading = "Enable Venue Order Setting";
        popup.message = `This will enable Venue Order Setting`;
      }
    } else {
      if (foodRunnerEnabled) {
        popup.heading = "Disable Food Runner Setting";
        popup.message = `This will disable Food Runner Setting`;
      } else {
        popup.heading = "Enable Food Runner Setting";
        popup.message = `This will enable Food Runner Setting`;
      }
    }
    popup.buttons = [
      {
        text: "No",
        onClick: () => this.setState({ popup: { type: "channels" } }),
      },
      {
        text: "Yes",
        onClick: () => {
          if (type === 'venueOrder')
            this.invokeVenueOrderChange();
          else
            this.invokeFoodRunnerChange();
        }
      },
    ];
    this.setState({ popup });
  };

  closePopup = (event, callback = () => { }) => {
    this.requestClicked = false;
    this.setState({ popup: undefined, selectedItem: {} }, () => !!callback && callback());
  };

  dismissPopup = (event, callback = () => { }) => {
    this.setState({ popup: undefined }, () => !!callback && callback());
  }

  setNotifications = () => {
    this.setState((prevState) => {
      return {
        ...prevState,
        showNotifications: !prevState.showNotifications,
        notificationControlEnabled: false,
        snoozeEnabled: false
      };
    });
  };

  dismissNotification = (notification) => {
    const { reduxProps, dispatchUpdateNotification } = this.props;
    const { notifications } = reduxProps;
    const notificationsCopy = notifications.slice();
    const notificationIndex = notificationsCopy.findIndex(
      (n) => n.notificationId === notification.notificationId
    );
    if (notificationIndex > -1) {
      notificationsCopy.splice(notificationIndex, 1, {
        ...notification,
        isDismissed: true,
      });
    }
    dispatchUpdateNotification(notificationsCopy);
    this.notificationTimeout && clearTimeout(this.notificationTimeout);
    this.notificationTimestamp = new Date().getTime();
  };

  ackNotification = (notification) => {
    const {
      reduxProps,
      dispatchAcknowledgeNotification,
      dispatchUpdateNotification,
    } = this.props;
    const { deviceApi, storeInfo } = reduxProps;
    const { id } = storeInfo?.data || {};
    const { deviceId } = deviceApi?.data;
    if (notification.notificationTypeId === 16) {
      const { notifications } = reduxProps;
      const notificationsCopy = notifications.slice();
      const notificationIndex = notificationsCopy.findIndex(
        (n) => n.notificationId === notification.notificationId
      );
      if (notificationIndex !== -1) {
        notificationsCopy.splice(notificationIndex, 1, {
          ...notification,
          isDismissed: true,
        });
      }
      dispatchUpdateNotification(notificationsCopy);
    }
    const payload = {
      deviceId: deviceId,
      storeId: id,
      notificationId: notification.notificationId,
    };
    dispatchAcknowledgeNotification(payload);
    this.notificationTimeout && clearTimeout(this.notificationTimeout);
    this.notificationTimestamp = new Date().getTime();
  };

  notificationGoAndDismiss = (notification) => {
    const selecteCheckOrderTypes = this.getSelectedCheckOrderTypes();
    const checkId = notification.data.checkHeaderId;
    const checkDetails = this.checks.get(checkId);
    if (checkDetails && Object.keys(checkDetails).length !== 0 && checkDetails.constructor === Object) {
      const orderStatusId = checkDetails.orderStatusId;
      const orderStatusTypeName = CommonUtil.getOrderNameFromId(orderStatusId);
      const orderStatusType = orderStatusTypeName ? [{ label: orderStatusTypeName, value: orderStatusTypeName }] : [];
      const orderTypeName = CommonUtil.getCheckOrderTypeName(checkDetails, this.activeCheckFilter, this.props?.reduxProps?.storeInfo);
      const orderType = orderTypeName ? [{ label: orderTypeName, value: orderTypeName }] : [];
      if (
        selecteCheckOrderTypes.length === 0 ||
        selecteCheckOrderTypes.includes(orderTypeName)
      ) {
        this.state.selectedItem = checkDetails;
        this.ackNotification(notification);
        this.setState(
          {
            items: checkDetails.items,
            orderType,
            orderStatusType,
            showNotifications: false,
          },
          () => {
            this.toggleSelection(true, () => {
              const { filteredChecklist } = this.state;
              const index = filteredChecklist.findIndex(
                (check) => check.checkHeaderId === checkId
              );
              if (index > -1) {
                // this.scrollToSection(index);
              }
            });
          }
        );
      }
    }
  };

  goToCheck = notification => {
    const selecteCheckOrderTypes = this.getSelectedCheckOrderTypes();
    const checkId = notification.data.checkHeaderId;
    const checkDetails = this.checks.get(checkId);
    if (checkDetails) {
      const orderStatusId = checkDetails.orderStatusId;
      const orderStatusTypeName = CommonUtil.getOrderNameFromId(orderStatusId);
      const orderStatusType = orderStatusTypeName ? [{ label: orderStatusTypeName, value: orderStatusTypeName }] : [];
      const orderTypeName = CommonUtil.getCheckOrderTypeName(checkDetails, this.activeCheckFilter, this.props?.reduxProps?.storeInfo);
      const orderType = orderTypeName ? [{ label: orderTypeName, value: orderTypeName }] : [];
      if (
        selecteCheckOrderTypes.length === 0 ||
        selecteCheckOrderTypes.includes(orderTypeName)
      ) {
        this.setState(
          {
            items: checkDetails.items,
            selectedItem: checkDetails,
            orderType,
            orderStatusType,
            showNotifications: false,
          },
          () => {
            this.setSelectedCheck(checkDetails);
            this.toggleSelection(true, () => {
              const { filteredChecklist } = this.state;
              const index = filteredChecklist.findIndex(check => check.checkHeaderId === checkId);
              if (index > -1) {
                // this.scrollToSection(index);
              }
            });
          },
        );
      }
    }
  };

  handleChange = (event) => {
    this.setState({ value: event.target.value });
  };

  getSpinner = (type: string, heading: any, message: any) => {
    const popup =
      type === "spinner"
        ? getPopupConfig("spinner")
        : getPopupConfig("error", () => {
          this.closePopup();
        });
    if (heading) {
      popup.heading = heading;
    }
    if (message) {
      popup.message = message;
    }
    this.setState({ popup });
  };

  // acknowledgeOverServe = (approved, notification, reason) => {
  //   this.getSpinner("spinner", constants.ackOverServe, null);
  //   const { reduxProps } = this.props;
  //   const { storeInfo, deviceInfo, login } = reduxProps;
  //   API.acknowledgeOverServe({
  //     deviceExternalId: deviceInfo.deviceExternalId,
  //     storeId: storeInfo.data.id,
  //     notificationId: notification.id,
  //     overServeReasonId: reason ? reason.id : null,
  //     approved,
  //     employeeId: login.data.id,
  //   })
  //     .then((response) => {
  //       console.info("response from acknowledgeOverServe", response);
  //       this.setState({ popup: undefined });
  //       FireboardUtils.addNetworkLogs(response);
  //     })
  //     .catch((error) => {
  //       console.debug("error from acknowledgeOverServe", error, error.response);
  //       this.handleErrorPopup(error);
  //     });
  // };

  acknowledgeIdCheck = (approved, notification) => {
    const { reduxProps } = this.props;
    const { storeInfo, deviceApi, login } = reduxProps;
    const { deviceId } = deviceApi?.data;
    this.getSpinner("spinner", constants.ackIdCheck, null);
    API.acknowledgeIdCheck({
      deviceId: deviceId,
      storeId: storeInfo.data.id,
      notificationId: notification.id,
      approved,
      employeeId: login.data.id,
    })
      .then((response) => {
        console.info("response from acknowledgeIdCheck", response);
        this.setState({ popup: undefined });
        FireboardUtils.addNetworkLogs(response);
      })
      .catch((error) => {
        console.debug("error from acknowledgeIdCheck", error, error.response);
        this.handleErrorPopup(error);
      });
  };

  invokeTextToPay = (payload) => {
    const { latitude, longitude } = UTILLib.location;
    const {
      phoneNumber,
      guestName,
      pickupTime,
      checkNumber,
      subTotal,
      tax,
      selectedCountry,
      preAuth,
    } = payload;
    const {
      reduxProps: { storeInfo, deviceApi },
    } = this.props;
    const { deviceId } = deviceApi?.data;
    const { selectedItem } = this.state;
    this.getPopup("spinner", constants.textToPayGenLoader, null);
    API.generateTextToPay({
      latitude,
      longitude,
      deviceId: deviceId,
      storeId: storeInfo.data.id,
      guestName,
      phoneNumber: FireboardUtils.inputUnFormattedPhnNum(phoneNumber, selectedCountry.iso2),
      checkNumber,
      subtotalAmount: +subTotal,
      taxAmount: +tax,
      pickupTime: pickupTime,
      countryCode: selectedCountry.dialCode.split('+')[1],
      checkHeaderId: selectedItem && selectedItem.checkHeaderId,
      preAuth: preAuth || false,
    })
      .then((response) => {
        console.debug("response from generateTextToPay", response);
        this.closePopup();
        FireboardUtils.addNetworkLogs(response);
      })
      .catch((error) => {
        const errorPopup = getPopupConfig("error");
        errorPopup.message = error.response
          ? error.response.data
          : error.message;
        EventEmitter.addLogs(
          'appLogs',
          LogLevelEnum.ERROR,
          `${errorPopup.message} checkNumber is ${checkNumber}`
        );
        FireboardUtils.addNetworkLogs(error.response);
        errorPopup.buttons = [
          {
            text: constants.cancelText,
            onClick: this.dismissPopup,
          },
          {
            text: constants.retry,
            onClick: () => {
              this.dismissPopup(null, () => this.invokeTextToPay(payload));
            },
          },
        ];
        this.setState({ popup: errorPopup });
      });
  };

  invokeCheckIn = (payload) => {
    const { latitude, longitude } = UTILLib.location;
    const { phoneNumber, guestName, pickupTime, checkNumber, selectedCountry, } = payload;
    const {
      reduxProps: { storeInfo, deviceApi },
    } = this.props;
    const { deviceId } = deviceApi?.data;
    const { selectedItem } = this.state;
    this.getPopup("spinner", constants.checkInRequestLoader, null);
    API.checkInRequest({
      latitude,
      longitude,
      deviceId: deviceId,
      storeId: storeInfo.data.id,
      guestName,
      phoneNumber: FireboardUtils.inputUnFormattedPhnNum(phoneNumber, selectedCountry.iso2),
      checkNumber,
      subtotalAmount: +0,
      taxAmount: +0,
      pickupTime: pickupTime,
      countryCode: selectedCountry.dialCode.split('+')[1],
      checkHeaderId: selectedItem && selectedItem.checkHeaderId,
    })
      .then((response) => {
        console.debug("response from checkInRequest", response);
        this.closePopup();
        FireboardUtils.addNetworkLogs(response);
      })
      .catch((error) => {
        console.warn(
          "error in generateTextToPay",
          error,
          error.request,
          error.response
        );
        const errorPopup = getPopupConfig("error");
        errorPopup.message = error.response
          ? error.response.data
          : error.message;
        EventEmitter.addLogs(
          'appLogs',
          LogLevelEnum.ERROR,
          `${errorPopup.message} checkNumber is ${checkNumber}`
        );
        FireboardUtils.addNetworkLogs(error.response);
        errorPopup.buttons = [
          {
            text: constants.cancelText,
            onClick: this.dismissPopup,
          },
          {
            text: constants.retry,
            onClick: () => {
              this.dismissPopup(null, () => this.invokeCheckIn(payload));
            },
          },
        ];
        this.setState({ popup: errorPopup });
      });
  };

  generateQRPay = check => {
    this.setState({
      popup: {
        type: POPUPS_ENUMS.GENERATE_QR_PAY,
        meta: check,
      },
    });
  };

  invokeScanToPay = (payload) => {
    const { latitude, longitude } = UTILLib.location;
    const { amount, checkNumber } = payload;
    const {
      reduxProps: { storeInfo, deviceApi },
    } = this.props;
    const { deviceId } = deviceApi?.data;
    this.getPopup("spinner", constants.payNowLoader, null);
    API.payNow({
      latitude,
      longitude,
      deviceId: deviceId,
      storeId: storeInfo.data.id,
      guestName: null,
      phoneNumber: null,
      checkNumber,
      subtotalAmount: +amount,
      pickupTime: null,
    })
      .then((response) => {
        console.debug("response from payNow", response);
        this.generateQRPay(response.data);
        FireboardUtils.addNetworkLogs(response);
      })
      .catch((error) => {
        console.warn(
          "error in generateTextToPay",
          error,
          error.request,
          error.response
        );
        const errorPopup = getPopupConfig("error");
        errorPopup.message = error.response
          ? error.response.data
          : error.message;
        EventEmitter.addLogs(
          'appLogs',
          LogLevelEnum.ERROR,
          `${errorPopup.message} checkNumber is ${checkNumber}`
        );
        FireboardUtils.addNetworkLogs(error.response);
        errorPopup.buttons = [
          {
            text: constants.cancelText,
            onClick: this.dismissPopup,
          },
          {
            text: constants.retry,
            onClick: () => {
              this.dismissPopup(null, () => this.invokeScanToPay(payload));
            },
          },
        ];
        this.setState({ popup: errorPopup });
      });
  };

  handleErrorPopup = (error) => {
    const errorMsg = error.response
      ? error.response.data
      : error.message;
    FireboardUtils.addNetworkLogs(error.response);
    this.getPopup("error", null, errorMsg);
  };

  showMemberDetailPopup = (memberId) => {
    this.getPopup("spinner", "Getting member details...", null);
    API.getMemberDetails({ memberId })
      .then((res) => {
        this.setState({
          popup: {
            type: POPUPS_ENUMS.MEMBER_DETAILS,
            metaData: res.data,
          },
        });
        FireboardUtils.addNetworkLogs(res);
      })
      .catch((error) => this.handleErrorPopup(error));
  };

  onPrintPress = (type, printMeta) => {
    const { selectedItem, items } = this.state;
    const { selectedCheckDetails } = selectedItem;
    const { id: checkId, number: checkNumber } = selectedCheckDetails || {};
    const {
      reduxProps: { storeInfo, deviceApi },
    } = this.props;
    const { deviceId } = deviceApi?.data;
    if (selectedCheckDetails && Object.keys(selectedCheckDetails).length === 0) {
      return;
    }
    let requestBody;
    let requestType;
    let printType;
    if (type === 'check') {
      if (printMeta.display === 'GUEST RECEIPT') {
        if (selectedItem && Object.keys(selectedItem).length !== 0) {
          this.printCheck(selectedItem);
          this.setSelectedCheck(selectedItem);
          printType = 'Guest Receipt';
        }
        return;
      } else if (printMeta.display === 'FULL ORDER LABEL') {
        requestBody = {
          storeId: storeInfo.data.id,
          deviceId: deviceId,
          checkHeaderId: selectedCheckDetails && selectedCheckDetails.id,
          includeItems: false,
        };
        requestType = 'printCheck';
        printType = 'Full Order Label';
      } else if (printMeta.display === 'ORDER + ITEMS LABELS') {
        requestBody = {
          storeId: storeInfo.data.id,
          deviceId: deviceId,
          checkHeaderId: selectedCheckDetails && selectedCheckDetails.id,
          includeItems: true,
        };
        requestType = 'printCheck';
        printType = 'Order + Items';
      } else if (printMeta.display === 'INDIVIDUAL ITEM LABELS') {
        requestBody = {
          storeId: storeInfo.data.id,
          deviceId: deviceId,
          checkHeaderId: selectedCheckDetails && selectedCheckDetails.id,
          checkItemIds: selectedCheckDetails && selectedCheckDetails.items.map(i => i.checkItemId),
        };
        requestType = 'printCheck';
        printType = 'Item Labels'
      } else if (printMeta.display === 'KITCHEN TICKET') {
        requestBody = {
          storeId: storeInfo.data.id,
          deviceId: deviceId,
          checkHeaderId: selectedCheckDetails && selectedCheckDetails.checkHeaderId,
        };
        requestType = 'printOrderTicket';
        printType = 'Kitchen Ticket';
      }
      this.getPopup('spinner', `Printing ${printMeta.display}`, null);
    } else if (type === 'item') {
      requestBody = {
        storeId: storeInfo.data.id,
        deviceId: deviceId,
        checkHeaderId: selectedCheckDetails && selectedCheckDetails.id,
        checkItemIds: [printMeta.checkItemId],
      };
      requestType = 'printItems';
      printType = 'Items';
      this.getPopup('spinner', 'Printing item', null);
    }
    API[requestType](requestBody)
      .then(response => {
        FireboardUtils.addNetworkLogs(response);
        console.info('response from print', response);
        const printPopup = getPopupConfig('spinner');
        printPopup.heading = response.data.printerName
          ? `${constants.printLoading} at ${response.data.printerName}`
          : constants.printLoading;
        let updatedItems = [];
        const isPOSOrder =
          CommonUtil.getOrderTypeFromSourceType(selectedCheckDetails.sourceType) ===
          constants.orderType_POS;
        if (isPOSOrder) {
          if (type === 'item') {
            Object.keys(items) &&
              Object.keys(items).forEach(eachKey => {
                updatedItems[eachKey] = items[eachKey].map(eachItem => {
                  if (eachItem.id === printMeta.checkItemId) {
                    return {
                      ...eachItem,
                      printed: true,
                    };
                  }
                  return eachItem;
                });
              });
          } else {
            Object.keys(items) &&
              Object.keys(items).forEach(eachKey => {
                updatedItems[eachKey] = items[eachKey].map(eachItem => ({
                  ...eachItem,
                  printed: true,
                }));
              });
          }
        } else if (type === 'item') {
          updatedItems = items.map(eachItem => {
            if (eachItem.id === printMeta.checkItemId) {
              return {
                ...eachItem,
                printed: true,
              };
            }
            return eachItem;
          });
        } else {
          updatedItems = items.map(eachItem => ({
            ...eachItem,
            printed: true,
          }));
        }
        this.setState({ popup: printPopup, items: updatedItems });
        if (printType === 'Kitchen Ticket') {
          const { printJobs } = response.data;
          const printDataArray = Array.isArray(printJobs) ? printJobs : [];
          printDataArray.forEach(data =>
            this.printReceipt({
              type: 'print',
              data,
              printType,
            }, checkId, checkNumber)
          );
        } else {
          var data = {
            type: "print",
            data: response.data,
            printType,
          };
          this.printReceipt(data, checkId, checkNumber);
        }
        setTimeout(() => {
          this.dismissPopup();
        }, 4000);
      })
      .catch(error => {
        console.debug('error', error, error.response);
        this.handleErrorPopup(error);
      });
  };

  printReceipt = (data, checkId, checkNumber) => {
    const { printerIpAddress, printerName, printerPort } = data?.data || {};
    const logData = {
      checkId,
      checkNumber,
      printerName,
      printerIpAddress,
      printType: data?.printType,
    };
    UTILLib.printReceipt(
      data,
      () => this.dismissPopup(),
      error => {
        console.warn('error while printing receipt', error);
        const popup = getPopupConfig('error', () => {
          this.setState({ popup: undefined });
        });
        popup.message = "Trying to connect to " + printerName + " with IP Address " + printerIpAddress + " and port " + printerPort + " " + error;
        this.setState({ popup });
        this.addPrintLog({ ...logData, status: 'FAILURE' });
      },
      () => {
        let popup = getPopupConfig('error', () => this.dismissPopup());
        popup.message = constants.extensionNotAvailable;
        this.setState({ popup });
        this.addPrintLog({ ...logData, status: 'SUCCESS' });
      },
    );
  };

  addPrintLog = logData => {
    const { checkId, checkNumber, printerName, printerIpAddress, status, printType } = logData || {};
    EventEmitter.addLogs(
      'appLogs',
      LogLevelEnum.INFO,
      `Print - ${moment(new Date).format('YYYY-MM-DD hh:mm:ss')} | Check Id - ${checkId} | Check Number - ${checkNumber} | Print Type - ${printType} | Printer Name - ${printerName} | Printer IP Address - ${printerIpAddress} | Print Status - ${status}`
    );
  };

  showCalendar = () => {
    this.setState({
      popup: {
        type: "calendar",
      },
    });
  };

  invokeGratuityApi = (gratuity) => {
    const { preAuthItem } = this.state;
    const { reduxProps } = this.props;
    const { storeInfo, deviceApi, login } = reduxProps;
    const { deviceId } = deviceApi?.data;
    const { latitude, longitude } = UTILLib.location;
    const unpaid = preAuthItem.unpaidAmount;
    const preauthTicket =
      preAuthItem.tickets &&
      preAuthItem.tickets.find(ticket => ticket.ticketStatusId === 0 && ticket.preAuth && unpaid > 0);
    const gratuityCalculated = ((unpaid * +gratuity) / 100);

    this.getSpinner('spinner', 'Posting payment', null);

    API.preAuthCompleteFB({
      latitude,
      longitude,
      geoLocation: `${latitude} ${longitude}`,
      storeId: storeInfo.data.id,
      deviceId: deviceId,
      employeeId: login && login.data && login.data.id,
      checkHeaderId: preAuthItem.id,
      ticketId: preauthTicket ? preauthTicket.id : null,
      totalAmount: +unpaid,
      tipAmount: +(gratuityCalculated.toFixed(2)),
      paymentAmount: +((unpaid + gratuityCalculated).toFixed(2)),
    })
      .then(res => {
        console.info('response from preAuthCompleteFB', res);
        const popup = getPopupConfig("success", this.dismissPopup);
        popup.heading = constants.paymentDoneSuccesssfully;
        popup.message = constants.paymentProcessed;
        this.setState({ popup });
        FireboardUtils.addNetworkLogs(res);
        const newCheck = res || {};
        const existingCheck = this.checks.get(newCheck.id);
        if (existingCheck) {
          this.checks.set(newCheck.id, {
            ...CommonUtil.parseCheckFromRedis(newCheck),
          });
        }
      })
      .catch(error => {
        console.info('error', error.request, error.response);
        this.handleErrorPopup(error);
      });
  };

  tipSubmit = (gratuity) => {
    const popup = getPopupConfig('error');
    popup.heading = constants.CustomTipConfirm;
    popup.message = constants.gratuityPostMessage;
    popup.buttons = [
      {
        text: constants.no,
        onClick: () => this.setState({ popup: { type: "fbPreAuth" } }),
      },
      {
        text: constants.yes,
        onClick: () => {
          this.invokeGratuityApi(gratuity);
        },
      },
    ];
    console.info('tipSubmit popup...', popup);
    this.setState({ popup });
  };

  onPreAuth = (item) => {
    this.getSpinner('spinner', 'Syncing pre auth check', null);
    const { reduxProps: { storeInfo, deviceApi, login } } = this.props;
    const { id: storeId } = storeInfo?.data || {};
    const { deviceId } = deviceApi?.data || {};
    const { id: employeeId } = login?.data || {};
    const payload = {
      storeId,
      deviceId,
      employeeId,
      checkHeaderId: item?.id,
    };
    API.syncIfModified(payload)
      .then(response => {
        const syncedCheck = response.data;
        let check = {};
        if (!FireboardUtils.isObjectBlank(syncedCheck)) {
          const parsedCheck = CommonUtil.parseCheckFromRedis(syncedCheck);
          this.checks.set(syncedCheck.id, parsedCheck);
          check = this.getFormattedCheck(parsedCheck);
          this.state.selectedItem = check;
        } else {
          check = { ...item };
        }

        this.setState({ popup: undefined }, () => {
          this.navigateToPreAuthScreen(check);
        });
      })
      .catch(error => this.handleErrorPopup(error));
  };

  navigateToPreAuthScreen = (item) => {
    const { history, reduxProps } = this.props;
    const { storeInfo } = reduxProps || {};
    const { defaultPreAuthTipPercentage } = storeInfo?.data || {};
    const { supportsGratuityForPreAuth } = storeInfo?.data?.serverAppFeatures || {};
    const { tickets = [] } = item || {};
    let preauthTickets = [];
    if (Array.isArray(tickets) && tickets.length) {
      preauthTickets = tickets.filter(ticket => ticket.ticketStatusId === 0 && ticket.preAuth && item.unpaidAmount > 0);
    }
    if (preauthTickets.length > 1) {
      this.setState({ popup: { type: "showMultiplePreauth", metaData: preauthTickets } });
    } else {
      history.push({
        pathname: '/fireboardPreAuth',
        state: {
          item: JSON.stringify(item),
          defaultPreAuthTipPercentage: defaultPreAuthTipPercentage,
          supportsGratuityForPreAuth: supportsGratuityForPreAuth,
          deviceTypeId: 15,
        }
      });
    }
  };

  onResyncCheck = item => {
    this.getPopup('spinner', constants.syncingCheck, null);
    API.syncCheck({
      checkHeaderId: item.checkHeaderId,
    })
      .then(response => {
        const checkData = CommonUtil.parseCheckFromRedis(response.data);
        this.checks.set(response.data.id, checkData);
        this.toggleSelection(true);
        const { selectedItem } = this.state;
        this.setState({ popup: undefined, selectedItem: { ...checkData, rowIndex: selectedItem.rowIndex } });
        FireboardUtils.addNetworkLogs(response);
      })
      .catch(error => {
        this.handleErrorPopup(error);
      });
  };

  onDateChange = (date) => {
    const { reduxProps } = this.props;
    const { storeInfo } = reduxProps;
    const { prepTime } = this.state;
    this.setState(
      (prevState) => ({
        selectedDate: date,
      }),
      () => {
        if (date) {
          this.getPopup("spinner", constants.getFutureOrders, null);
          const { latitude, longitude } = UTILLib.location;
          const convertedDate = FireboardUtils.convertedDate(date);
          API.getFutureOrders({
            latitude,
            longitude,
            storeId: storeInfo.data.id,
            businessDate: convertedDate,
          })
            .then((res) => {
              const filteredChecklist = res.data.slice().map((check) => {
                let updatedCheck = {
                  ...CommonUtil.parseCheckFromRedis(check),
                  isNew: check.isNew || false,
                };
                const dueTime = CommonUtil.getDueTime(updatedCheck);
                updatedCheck = {
                  ...updatedCheck,
                  elapsedTime: FireboardUtils.getElapsedTime(updatedCheck, prepTime),
                  dueTime: new Date(dueTime).getTime(),
                  dueTimeDisplay: dueTime,
                };
                return updatedCheck;
              });
              this.futureCheckItems = filteredChecklist;
              this.setState({
                popup: undefined,
                filteredChecklist,
                selectedItem: {},
                items: [],
              });
              FireboardUtils.addNetworkLogs(res);
            })
            .catch((error) => {
              console.debug(
                "error from getFutureOrders api",
                error,
                error.response
              );
              this.futureCheckItems = [];
              this.state.filteredChecklist = [];
              this.handleErrorPopup(error);
            });
        } else {
          this.toggleSelection();
        }
      }
    );
  };

  snoozeInterval = () => {
    clearInterval(this.snoozeTimeInterval);
    this.snoozeTimeInterval = setInterval(() => {
      this.setState({ snoozeEnabled: false });
    }, 1 * TimeConstants.MINUTE);
    this.setState({ snoozeEnabled: true });
  };

  getNewCheckCount = (sourceType) => {
    let count = 0;
    Array.from(this.checks.values()).forEach((check) => {
      if (!check || !check.isNew) {
        return;
      }
      if (check.sourceType === sourceType) {
        count++;
      }
    });
    return count;
  };

  getPendingCount = (sourceType) => {
    let count = 0;
    Array.from(this.checks.values()).forEach((check) => {
      if (
        check.sourceType === sourceType &&
        (check.orderStatusId === 1 || check.orderStatusId === 0)
      ) {
        count++;
      }
    });
    return count;
  };

  getPreauthCount = () => {
    const preAuthfilterFunction = check => check.tickets && check.tickets.some(tkt => tkt.preAuth && tkt.ticketStatusId === 0 && check.unpaidAmount > 0);
    const allChecks = Array.from(this.checks.values());
    const preAuthChecks = allChecks.filter(preAuthfilterFunction);
    return preAuthChecks.length;
  };

  getSubTypes = (type) => {
    const { reduxProps } = this.props;
    const { storeInfo } = reduxProps;
    let subTypes = [];
    if (type === "orderType") {
      subTypes = [allOrderType].concat(storeInfo.data.orderTypes.slice());
    } else if (type === "revenueCenter") {
      subTypes = [allOrderType].concat(storeInfo.data.revenueCenters.slice());
    } else {
      subTypes = [allOrderType].concat(storeInfo.data.sensorGroups.slice());
    }

    if (subTypes && subTypes.length > 0) {
      return subTypes.map((each) => each.name);
    }
    return [];
  };

  getOrderTypes = () => {
    let orderTypesArr = [];
    if (this.activeCheckFilter === "sourceType") {
      orderTypesArr = this.checkSourceTypes.length === 0
        ? data.orderTypes
        : this.checkSourceTypes;
    } else if (this.activeCheckFilter === "orderType") {
      orderTypesArr = this.checkOrderTypes.length === 0
        ? this.getSubTypes("orderType")
        : this.checkOrderTypes;
    } else if (this.activeCheckFilter === "revenueCenter") {
      orderTypesArr = this.checkRevenueTypes.length === 0
        ? this.getSubTypes("revenueCenter")
        : this.checkRevenueTypes;
    } else {
      orderTypesArr = this.checkSensorGroupTypes.length === 0
        ? this.getSubTypes("sensorGroup")
        : this.checkSensorGroupTypes;
    }

    if (Array.isArray(orderTypesArr) && !orderTypesArr.includes("All"))
      return ["All"].concat(orderTypesArr);
    return orderTypesArr;
  };

  getManagerNotifications = () => {
    const { reduxProps } = this.props;
    const { managerMode } = this.state;
    const { notifications } = reduxProps;
    if (managerMode) {
      // return notifications.filter(n => n.notificationTypeId === 14 || n.notificationTypeId === 15);
      return notifications.filter(n => n.notificationTypeId === 14);
    }
    return [];
  };

  onLogout = () => {
    this.checks.forEach(each => {
      this.checks.set(each.id, { ...each, selectedForBatchPreauth: false, });
    });
    this.setState({
      managerMode: false,
      selectedItem: {},
      items: [],
      batchPreauth: false,
      //normal fb can show the filter that was selected before entering manager mode
      orderType: this.prevOrderType || ALLOPTION, //restore previous order type filter
      orderStatusType: this.prevOrderStatusType || ALLOPTION, //restore previous order status filter
      selectedVenueStore: this.prevVenueStore || allStoreOption, //restore previous venue store name filter
    }, () => {
      this.toggleSelection(true);
    });
    const { history } = this.props;
    if (history && history.location && history.location.state && history.location.state.managerMode) {
      const state = { ...history.location.state };
      state.managerMode = false;
      history.replace({ ...history.location, state });
    }
  }

  // showApprovalReasonsPopup = (approval, notification) => {
  //   const { reduxProps } = this.props;
  //   const { storeInfo } = reduxProps;
  //   const { overServeApproveReasons, overServeRejectReasons } = storeInfo.data;
  //   if (approval) {
  //     if (overServeApproveReasons && overServeApproveReasons.length > 0) {
  //       const popup = {};
  //       popup.type = 'overServerReasons';
  //       this.setState({
  //         popup,
  //         reasonsList: overServeApproveReasons,
  //         reasonType: 'approval',
  //         overServerNotification: notification,
  //       });
  //     } else {
  //       this.acknowledgeOverServe(true, notification);
  //     }
  //   } else if (overServeRejectReasons && overServeRejectReasons.length > 0) {
  //     const popup = {};
  //     popup.type = 'overServerReasons';
  //     this.setState({
  //       popup,
  //       reasonsList: overServeRejectReasons,
  //       reasonType: 'reject',
  //       overServerNotification: notification,
  //     });
  //   } else {
  //     this.acknowledgeOverServe(false, notification);
  //   }
  // };

  resetSelectedReason = () => {
    this.setState({ selectedReason: {} });
  };

  // submitReason = () => {
  //   const { selectedReason, reasonType, overServerNotification } = this.state || {};
  //   if (reasonType === 'approval') {
  //     this.acknowledgeOverServe(true, overServerNotification, selectedReason);
  //   } else if (reasonType === 'reject') {
  //     this.acknowledgeOverServe(false, overServerNotification, selectedReason);
  //   }
  // };

  onPressReason = reason => {
    if (reason) {
      this.setState({ selectedReason: reason });
    }
  };

  isSensorGroupFilterEnabled = () => {
    return this.activeCheckFilter === 'sensorGroup';
  };

  toggleView = viewType => {
    this.setState({ currentView: viewType }, () => {
      if (this.state.currentView === 'layout') {
        this.onChangeSensorGroup();
      } else {
        this.state.orderType = ALLOPTION;
        this.toggleSelection();
      }
    });
  };

  get getTables() {
    const { reduxProps } = this.props;
    const { storeInfo } = reduxProps;
    const stations = RethinkUTIL.getStations(this.checks);
    const tables = FireboardUtils.parseStationInfo(stations, storeInfo);
    return tables ? tables : [];
  };

  getStoreLayoutBySensorGroupId = (sensorGroupId) => {
    if (sensorGroupId) {
      const { reduxProps: { storeInfo } } = this.props;
      const { id: storeId } = storeInfo?.data || {};
      this.getPopup('spinner', constants.fetchingStoreLayout, null);
      API.getStoreLayoutBySensorGroup(storeId, sensorGroupId)
        .then(response => {
          const { layoutJson } = response.data;
          this.parseLayoutJson(layoutJson);
        })
        .catch(error => this.handleErrorPopup(error));
    } else {
      //if no sensor group is selected - reset shapes, selectedShape, selectedTable & selectedItem
      this.setState({
        selectedShape: null,
        shapes: new Map(),
        selectedTable: null,
        selectedItem: {},
      }, () => this.toggleSelection());
    }
  };

  getStoreLayout = storeId => {
    API.getStoreLayout(storeId)
      .then(response => {
        let { layoutJson } = response.data;
        this.layoutJson = layoutJson;
        this.parseLayoutJson(layoutJson);
        FireboardUtils.addNetworkLogs(response);
      })
      .catch(error => this.handleErrorPopup(error));
  };

  parseLayoutJson = layoutJson => {
    try {
      let shapes = new Map();
      const parsedShapes = JSON.parse(layoutJson);
      if (parsedShapes && Object.keys(parsedShapes).length !== 0 && parsedShapes.constructor === Object) {
        shapes = new Map(Object.entries(parsedShapes));
      }
      this.state.shapes = shapes;
      this.state.selectedItem = {};
      this.state.selectedTable = null;
      this.state.selectedShape = null;
      this.state.popup = undefined;
      this.filterShapeBySensorGroup();
    } catch (error) {
      console.error(`error in layoutJson parsing - ${error}`);
    }
  };

  filterShapeBySensorGroup = () => {
    let copiedShapes = new Map(this.state.shapes);
    //remove other shapes (only tables) which are not belongs to selected sensor group
    if (!this.storeLayoutBySensorGroup && this.isSensorGroupFilterEnabled()) {
      const { reduxProps: { storeInfo } } = this.props;
      const { orderType, shapes } = this.state;
      const orderTypeName = (Array.isArray(orderType) && orderType.length > 0) ? orderType[0].value : '';
      if (orderTypeName && orderTypeName !== 'All') {
        const { sensorGroups } = storeInfo?.data || {};
        const sensorGroup = Array.isArray(sensorGroups)
          ? sensorGroups.find(sensorGrp => (sensorGrp.name).toLowerCase().trim() === orderTypeName.toLowerCase().trim())
          : null;
        let stationIds = [];
        if (sensorGroup) {
          //get all sensors which are associated to selected sensor group
          const sensors = this.sensorsMap.has(sensorGroup.id) ? this.sensorsMap.get(sensorGroup.id) : [];
          sensors.forEach(sensor => {
            if (sensor?.stationId) {
              stationIds.push(sensor.stationId);
            }
          });
        }
        //remove all tables which are not associated to selected sensor group
        for (const [id, shape] of shapes) {
          if (shape && shape?.stationId && !stationIds.includes(shape.stationId)) {
            copiedShapes.delete(id);
          }
        }
      }
    }
    this.setState({ shapes: copiedShapes }, () => this.toggleSelection());
  };

  onChangeSensorGroup = () => {
    //if both flag are true - call get store layout by selected sensor group
    if (this.storeLayoutBySensorGroup && this.isSensorGroupFilterEnabled()) {
      const { reduxProps: { storeInfo } } = this.props;
      const { sensorGroups } = storeInfo?.data || {};
      const { orderType } = this.state;
      const orderTypeName = (Array.isArray(orderType) && orderType.length > 0) ? orderType[0].value : '';
      const sensorGroup = Array.isArray(sensorGroups)
        ? sensorGroups.find(sensorGrp => (sensorGrp.name).toLowerCase().trim() === orderTypeName.toLowerCase().trim())
        : null;
      this.getStoreLayoutBySensorGroupId(sensorGroup?.id);
    } else {
      this.parseLayoutJson(this.layoutJson);
    }
  };

  getTableColor = (checksArray) => {
    let color = 'green';
    if (Array.isArray(checksArray)) {
      if (checksArray.length === 0) {
        color = 'green';
      } else {
        const isCheckOpened = checksArray.some(check => check.open);
        if (isCheckOpened)
          color = 'orange';
      }
    }
    return color;
  };

  setShapeChecks = (checkList) => {
    const { shapes, selectedShape } = this.state;
    const allShapes = Array.from(shapes.values());
    let updatedShapes = new Map(shapes);
    if (allShapes.length) {
      //Map<stationId, checkArray>
      let chMap = new Map();
      checkList && Array.isArray(checkList) && checkList.forEach(check => {
        if (check.stationId && check.open) {
          if (chMap.has(check.stationId)) {
            chMap.set(check.stationId, [...chMap.get(check.stationId), check]);
          } else {
            chMap.set(check.stationId, [check]);
          }
        }
      });

      let newTableChecks = new Map(); //Map<stationId, checkArray>
      allShapes.forEach(eachShape => {
        const shapeStationId = eachShape.stationId;
        if (shapeStationId) {
          const checkArray = chMap.has(shapeStationId) ? chMap.get(shapeStationId) : [];
          newTableChecks.set(shapeStationId, checkArray);

          //update shape color and others properties
          updatedShapes.set(eachShape.id, {
            ...eachShape,
            stroke: this.getTableColor(checkArray),
          });
        }
      });

      this.tableChecks = newTableChecks;
    }
    this.setState({ updatedShapes });

    //update selected check if any selected
    if (selectedShape) {
      this.onSelectShape(selectedShape);
    }
  };

  onSelectShape = selectedShape => {
    if (selectedShape?.stationId) {
      const stationId = selectedShape.stationId;
      const tables = this.getTables;
      const selectedTable = tables.find(table => table.stationId === stationId);
      const checkList = this.tableChecks.get(stationId);

      const filteredChecks = Array.isArray(checkList)
        ? checkList.map(eachCheck => this.getFormattedCheck(eachCheck))
        : [];

      this.setState({
        selectedShape,
        selectedTable: { ...selectedTable, checks: filteredChecks || [] },
        selectedItem: filteredChecks.length > 0 ? filteredChecks[0] : {}, //set initial selected check
      });
    }
  };

  onTabChange = (id) => {
    const { selectedTable } = this.state;
    const { checks } = selectedTable || {};
    if (Array.isArray(checks)) {
      const check = checks.find(ch => ch.id === id);
      if (check) {
        this.setState({ selectedItem: check });
      }
    }
  };

  closeShapeInfoPopup = () => {
    this.setState({
      selectedShape: null,
      selectedTable: {},
    });
  };

  onLoginPress = (id, indentifier) => {
    if (indentifier) {
      this.validateLogin(id, indentifier);
      return;
    }

    //login required to launch external app
    if (this.allowExternalAppLaunch) {
      const { reduxProps: { deviceApi }, dispatchLogin } = this.props;
      const { deviceId } = deviceApi?.data;
      this.employeeIdForExternalApp = id || null;
      dispatchLogin(deviceId, id || null, null, false);
      return;
    }

    const { managerMode } = this.state;
    if (!managerMode) {
      const { reduxProps: { deviceApi }, dispatchLogin } = this.props;
      const { deviceId } = deviceApi?.data;
      dispatchLogin(deviceId, id || null, null, true);
    }
  };

  onOutOfStockItemsPress = (type, update) => {
    const { history } = this.props;
    history && history.push(`/outOfStock/${type}`);
    // const { outOfStockSearchList } = this.state;
    // this.getOutOfStockList(type);
    // this.setState({ outOfStockMode: type, popup: { type }, outOfStockSearchList: update ? [] : outOfStockSearchList });
  };

  getOutOfStockList = type => {
    this.getPopup('spinner', 'Getting out of stock list');
    let req = 'getOutOfStockItemList';
    if (type === 'modifiers') req = 'getOutOfStockModifierList';
    const { reduxProps } = this.props;
    const { storeInfo } = reduxProps;
    const { id } = storeInfo.data;

    API[req]({
      storeId: id,
    }).then(res => {
      this.setState(
        {
          outOfStockItems: res.data,
          isClickedOutOfStock: true,
          outOfStockMode: type,
          popup: { type }
        },
      );
      FireboardUtils.addNetworkLogs(res);
    }).catch(error => {
      this.handleErrorPopup(error);
    })
  };

  searchOutOfStockItems = (type, value) => {
    this.getPopup('spinner', 'Searching items');
    const { reduxProps } = this.props;
    const { storeInfo } = reduxProps;
    const { id } = storeInfo.data;
    const { includeUnavailable } = this.state;
    let req = 'searchItemStock';
    if (type === 'modifiers') req = 'searchModifierStock';
    API[req]({
      storeId: id,
      postId: null,
      name: value,
      includeUnavailable,
    }).then(res => {
      this.setState({
        outOfStockSearchList: res.data,
        isClickedOutOfStock: false,
        popup: { type },
      });
      FireboardUtils.addNetworkLogs(res);
    }).catch(error => {
      console.info('error', error.request, error.response);
      this.handleErrorPopup(error);
    })
  };

  updateItemStock = (item, type) => {
    const oldPopup = this.state.popup;
    const popup = getPopupConfig('error');
    popup.heading = 'Update the item stock ?';
    popup.message = 'This will update the items stock status';
    popup.buttons = [
      {
        text: 'Cancel',
        onClick: () => {
          this.setState({
            popup: oldPopup,
          });
        },
      },
      {
        text: 'Proceed',
        onClick: () => {
          this.getPopup('spinner', 'Updating item stock');
          let request = 'updateItemStock';
          if (type === 'modifiers') request = 'updateModifierStock';
          const { reduxProps } = this.props;
          const { storeInfo } = reduxProps;
          const { id } = storeInfo.data;
          API[request]({
            storeId: id,
            id: item.id,
            stocked: !item.stocked,
          }).then(res => {
            console.info('res', res.data);
            this.updateItem({ ...res.data }, type);
            FireboardUtils.addNetworkLogs(res);
          }).catch(error => {
            console.info('error', error.request, error.response);
            this.handleErrorPopup(error);
          })
        },
      }
    ];
    this.setState({ popup });
  }

  updateItem = (updatedItem, type) => {
    const { outOfStockItems, isClickedOutOfStock, outOfStockSearchList } = this.state;
    const copiedItems = outOfStockItems.slice();
    const itemIndex = copiedItems.findIndex(mi => mi.id === updatedItem.id);
    if (itemIndex > -1) {
      if (isClickedOutOfStock) {
        copiedItems.splice(itemIndex, 1);
      } else {
        copiedItems.splice(itemIndex, 1, updatedItem);
      }
    }
    this.setState({
      outOfStockItems: copiedItems,
      outOfStockSearchList: outOfStockSearchList.map(i => {
        if (i.id === updatedItem.id) {
          return {
            ...i,
            stocked: !i.stocked,
          }
        }
        return { ...i };
      })
    }, () => this.onOutOfStockItemsPress(type, false));
  };

  doPairWatch = value => {
    const { reduxProps: { deviceApi }, dispatchLogin } = this.props;
    const { loginInfo } = this.state;
    if (loginInfo) {
      this.pairWatch(value);
      return;
    }
    const popup = getPopupConfig('spinner');
    this.setState({ popup });
    const { deviceId } = deviceApi?.data;
    this.allowPairWatch = true;
    dispatchLogin(deviceId, value || null, null, false);
  };

  onMarketplaceStatusPress = data => {
    if (data && data.testButton) {
      console.log('Hurray, the Marketplace Status test button was pressed 😀');
    }
  };

  pairWatch = code => {
    const { loginInfo } = this.state;
    const { reduxProps: { storeInfo } } = this.props;
    const spinner = getPopupConfig('spinner');
    this.setState({ popup: spinner });
    API.pairWatch({
      employeeId: loginInfo && loginInfo.id,
      storeId: storeInfo.data.id,
      uuid: '',
      activationCode: code,
    }).then(res => {
      console.info('res', res);
      this.setState({ popup: undefined });
      FireboardUtils.addNetworkLogs(res);
    }).catch(error => {
      console.info('error', error.response);
      this.handleErrorPopup(error);
    });
  };

  openPaymentHistory = () => {
    this.setState({ popup: { type: 'repostpayment' } });
  };

  rePostPayment = ticket => {
    const { reduxProps, dispatchRetryPOS } = this.props;
    const { storeInfo, deviceApi } = reduxProps || {};
    const { id: storeId } = storeInfo?.data || {};
    const { deviceId } = deviceApi?.data;
    const payload = {
      employeeId: null,
      storeId,
      deviceId,
      employeeCard: null,
      ticketId: ticket?.ticketId,
      checkTicketId: ticket?.id,
    };
    dispatchRetryPOS && dispatchRetryPOS(payload);
  };

  handleRetryPOSPayment = reduxProps => {
    const { reduxProps: prevReduxProps } = this.props;
    if (reduxProps.retryPOSPayment.timestamp !== prevReduxProps.retryPOSPayment.timestamp) {
      if (reduxProps.retryPOSPayment.data) {
        const popup = getPopupConfig('success', () => {
          this.setState({ popup: undefined });
        });
        this.setState({ popup });
      } else if (reduxProps.retryPOSPayment.error) {
        const popup = getPopupConfig('error', () => {
          this.setState({ popup: undefined });
        });
        popup.message = reduxProps.retryPOSPayment.error;
        this.setState({ popup });
      } else if (reduxProps.retryPOSPayment.isFetching) {
        const popup = getPopupConfig('spinner');
        popup.heading = 'Posting Payment';
        this.setState({ popup });
      }
    }
  };

  onChangeSmsType = () => {
    const { isCustomSmsType } = this.state
    this.setState({ isCustomSmsType: !isCustomSmsType });
  };

  getCustomSmsTemplates = () => {
    const { reduxProps } = this.props;
    const { storeInfo } = reduxProps || {};
    const { id: storeId } = storeInfo?.data || {};
    API.getCustomSmsTemplates(storeId)
      .then(response => {
        let { isCustomSmsType, customSmsList } = this.state;
        isCustomSmsType = (response.data && response.data.length > 0) ? true : false;
        customSmsList = response.data || [];
        if (customSmsList && customSmsList.length > 0) {
          this.notifyOrderPrepared = customSmsList.find(each => each.smsTemplate?.smsType === 110) || {};
          this.notifyOrderReady = customSmsList.find(each => each.smsTemplate?.smsType === 112) || {};
        }
        this.setState({ isCustomSmsType, customSmsList });
        FireboardUtils.addNetworkLogs(response);
      })
      .catch(error => {
        this.handleErrorPopup(error);
      });
  };

  viewErrorOrders = () => {
    const errorOrderStatus = [{ label: constants.orderError, value: constants.orderError }];
    this.setState({
      orderStatusType: errorOrderStatus,
      orderType: ALLOPTION,
      popup: undefined,
    }, () => this.toggleSelection());
    this.acknowledgeErrorOrder();
  };

  acknowledgeErrorOrder = () => {
    const { context } = this.props;
    const { resetErrorOrderFlag } = context;
    resetErrorOrderFlag && resetErrorOrderFlag();
  };

  getSensorGroupsFromStoreInfo = () => {
    const { reduxProps: { storeInfo } } = this.props;
    const { sensorGroups } = storeInfo?.data || {};
    this.sensorGroupsList = sensorGroups;
    this.setState({ popup: { type: 'sensorGroups' } });
  };

  openEditSensorGroupPopup = sensorGroup => {
    this.sensorGroup = sensorGroup;
    this.setState({ popup: { type: 'editSensorGroup' } });
  };

  updateSensorGroup = payload => {
    this.getSpinner('spinner', constants.updatingSensorGroup, null);
    API.updateSensorGroup(payload)
      .then(response => {
        const index = this.sensorGroupsList.findIndex(sensorGrp => sensorGrp.id === payload.id);
        this.sensorGroupsList.splice(index, 1, response.data);
        this.setState({ popup: { type: 'sensorGroups' } });
        FireboardUtils.addNetworkLogs(response);
      })
      .catch(error => this.handleErrorPopup(error));
  };

  closeEditSensorGroupPopup = () => {
    this.setState({ popup: { type: 'sensorGroups' } });
  };

  onClickBulkPreAuth = () => {
    const preAuthfilterFunction = check => check.tickets && check.tickets.some(tkt => tkt.preAuth && tkt.ticketStatusId === 0 && check.unpaidAmount > 0);
    const filteredChecks = this.checksRowData;
    const filteredPreAuthChecks = filteredChecks.filter(preAuthfilterFunction);
    this.bulkPreAuthChecks = [];
    if (filteredPreAuthChecks && Array.isArray(filteredPreAuthChecks) && filteredPreAuthChecks.length > 0) {
      this.bulkPreAuthChecks = filteredPreAuthChecks;
      this.setState({ popup: { type: 'batchPreauth' } });
    } else {
      this.getPopup('error', 'Alert', 'There is no pre auth checks');
    }
  };

  updateCheckAfterPreauthTipSubmit = check => {
    this.checks.set(check.id, CommonUtil.parseCheckFromRedis(check));
  };

  onPressRedeemVoucher = () => {
    this.setState({ popup: { type: 'redeemCheckVoucher' } });
  };

  onRedeemVoucher = (type, data) => {
    if (type === 'scanToRedeem' && window.ReactNativeWebView) {
      EventEmitter.scanQRCodeToRedeem('scanToRedeem');
    } else if (type === 'redeemCode') {
      const { first, last } = data || {};
      this.showRedeemConfirmation({
        voucherCodeTextFirst4: first,
        voucherCodeTextLast4: last,
      });
    } else if (type === 'managerOverride') {
      const { employeeCode } = data || {};
      this.showRedeemConfirmation({
        employeeCode: employeeCode,
      });
    }
  };

  onVoucherScanned = qrCode => {
    if (this.redeemOnlyVoucher) {
      this.redeemOnlyVoucher = false;
      this.callVoucherSearchAPI({
        voucherQrCode: qrCode
      });
      return;
    }
    this.showRedeemConfirmation({
      voucherQrCode: qrCode,
    });
  };

  onRedeemSearchedVoucher = () => {
    const { checkHeader, message } = this.searchedVoucher || {};
    const callback = () => {
      const { reduxProps: { storeInfo, deviceApi } } = this.props;
      const { id: storeId } = storeInfo?.data || {};
      const { deviceId } = deviceApi?.data;
      const { vouchers, id: checkHeaderId } = checkHeader || {};
      const voucher0 = (Array.isArray(vouchers) && vouchers.length) ? vouchers[0] : {};
      const { id: checkVoucherId } = voucher0 || {};
      this.getPopup('spinner', 'Applying Voucher', null);
      API.voucherCheckIn({
        storeId,
        deviceId,
        checkHeaderId,
        checkVoucherId,
      })
        .then(response => {
          this.setState({ popup: undefined });
          FireboardUtils.addNetworkLogs(response);
        })
        .catch((error) => this.handleErrorPopup(error));
    };

    const popup = getPopupConfig('error');
    popup.heading = 'Confirmation';
    const errorMsg = 'This will redeem the voucher and send any items to the kitchen. This action cannot be undone. Do you want to continue?';
    if (!!message) {
      popup.message = {
        errorMessage: errorMsg,
        errorConfirmationMsg: `Warning: ${message}.`,
      };
    } else {
      popup.message = errorMsg;
    }
    popup.buttons = [
      {
        text: 'No',
        onClick: () => this.setState({ popup: undefined })
      },
      {
        text: 'Yes',
        onClick: () => callback && callback()
      }
    ];
    this.setState({ popup });
  };

  showRedeemConfirmation = payload => {
    const callback = () => {
      const { selectedItem } = this.state;
      const { id: checkHeaderId } = selectedItem || {};
      const { reduxProps: { storeInfo, deviceApi } } = this.props;
      const { id: storeId } = storeInfo?.data || {};
      const { deviceId } = deviceApi?.data;
      const newPayload = {
        ...payload,
        storeId,
        deviceId,
        checkHeaderId,
      };
      this.getPopup('spinner', 'Applying Voucher', null);
      API.voucherCheckIn(newPayload)
        .then(response => {
          const newCheck = response.data;
          const { managerMode, prepTime } = this.state;
          if (!managerMode && this.showFutureOrders) {
            const dueTime = CommonUtil.getDueTime(newCheck);
            const newUpdatedCheck = {
              ...CommonUtil.parseCheckFromRedis(response.data),
              isNew: false,
              elapsedTime: FireboardUtils.getElapsedTime(newCheck, prepTime),
              dueTime: new Date(dueTime).getTime(),
              dueTimeDisplay: dueTime,
            };
            let list = this.futureCheckItems.filter(c => c.id !== newCheck.id);
            this.futureCheckItems = [...list, newUpdatedCheck];
          } else {
            this.checks.set(newCheck.id, CommonUtil.parseCheckFromRedis(newCheck));
          }
          this.setState({ popup: undefined });
          this.toggleSelection(true);
          FireboardUtils.addNetworkLogs(response);
        })
        .catch((error) => this.handleErrorPopup(error));
    };

    const oldPopup = this.state.popup;
    const popup = getPopupConfig('error');
    popup.heading = 'Confirmation';
    popup.message = 'This will redeem the voucher and send any items to the kitchen. This action cannot be undone. Do you want to continue?';
    popup.buttons = [
      {
        text: 'No',
        onClick: () => this.setState({ popup: oldPopup })
      },
      {
        text: 'Yes',
        onClick: () => {
          callback && callback();
        },
      }
    ];
    this.setState({ popup });
  };

  onVoucherSearch = code => {
    this.callVoucherSearchAPI({
      voucherCodeTextFirst4: code?.first,
      voucherCodeTextLast4: code?.last,
    });
  };

  callVoucherSearchAPI = payload => {
    const { reduxProps: { storeInfo, deviceApi } } = this.props;
    const { id: storeId } = storeInfo?.data || {};
    const { deviceId } = deviceApi?.data;
    const newPayload = {
      ...payload,
      storeId,
      deviceId,
    };
    this.getPopup('spinner', 'Searching For Voucher', null);
    API.voucherSearch(newPayload)
      .then(response => {
        this.searchedVoucher = response.data;
        this.setState({ popup: { type: 'redeemSearchedVoucher' } });
        FireboardUtils.addNetworkLogs(response);
      })
      .catch(error => this.handleErrorPopup(error));
  };

  navigateToSensor = sensorType => {
    const { history } = this.props;
    let pathName = '';
    if (sensorType === 'table')
      pathName = '/tableSensors';
    else if (sensorType === 'named')
      pathName = '/namedSensors';

    this.dismissPopup();
    pathName && history && history.push(pathName);
  };

  getProductionRate = (callback, showSpinner) => {
    const { reduxProps: { storeInfo } } = this.props;
    const { id: storeId } = storeInfo?.data || {};
    if (showSpinner) {
      this.getPopup('spinner', 'Fetching Productions Rate', null);
    }
    API.getStoreProductions(storeId)
      .then(response => {
        this.productionRateList = Array.isArray(response.data) ? response.data : [];
        if (this.state.productionOverrideReasons.length === 0) {
          this.getProductionOverrideReasons();
        }
        this.setPrepWindowAndProduction();
        FireboardUtils.addNetworkLogs(response);
        callback && callback();
      })
      .catch(error => this.handleErrorPopup(error));
  };

  getProductionOverrideReasons = () => {
    API.getProductionOverrideReasons()
      .then(response => {
        const reasons = Array.isArray(response.data) ? response.data : [];
        this.setState({ productionOverrideReasons: reasons });
        FireboardUtils.addNetworkLogs(response);
      })
      .catch(error => this.handleErrorPopup(error));
  };

  onManageOverrides = (actionType, production, productionIds) => {
    if (actionType === storeProductionEnum.CLEAR) {
      const { reduxProps: { storeInfo } } = this.props;
      const { id: storeId } = storeInfo?.data || {};
      this.overrideStoreProductionPayload = {
        id: production?.id,
        storeId: storeId,
        overrideProduction: null,
        overridePrepWindow: null,
      };
      this.setState({
        popup: {
          type: 'managerLogin',
          metaData: { indentifier: checkEnum.STORE_PRODUCTION, onClose: this.openProductionRatePopup }
        }
      });
    } else if (actionType === storeProductionEnum.EDIT) {
      this.productionRateForEdit = production;
      this.setState({ popup: { type: 'editProductionRate', metaData: { actionType } } });
    } else if (actionType === storeProductionEnum.BULKEDIT) {
      this.productionRateForEdit = production;
      this.productionRateIdsForEdit = productionIds;
      this.setState({ popup: { type: 'editProductionRate', metaData: { actionType } } });
    }
  };

  openProductionRatePopup = () => {
    this.setState({ popup: { type: 'productionRateList' } });
  };

  onEditProductionRate = (overrideValues, actionType) => {
    const { reduxProps: { storeInfo } } = this.props;
    const { id: storeId } = storeInfo?.data || {};
    this.overrideStoreProductionPayload = {
      id: actionType === storeProductionEnum.BULKEDIT ? 0 : this.productionRateForEdit?.id,
      ids: actionType === storeProductionEnum.BULKEDIT ? this.productionRateIdsForEdit : [],
      storeId: storeId,
      overrideProduction: +overrideValues?.overrideProduction,
      overridePrepWindow: +overrideValues?.overridePrepWindow,
      productionOverrideReason: +overrideValues.productionOverrideReason,
      comment: overrideValues.comment || '',
    };
    this.setState({
      popup: {
        type: 'managerLogin',
        metaData: { indentifier: checkEnum.STORE_PRODUCTION, onClose: this.openProductionRatePopup }
      }
    });
  };

  onOverrideStoreProduction = employeeId => {
    const payload = {
      ...this.overrideStoreProductionPayload,
      employeeId,
    };
    this.getPopup('spinner', 'Overriding Production Rate', null);
    API.overrideStoreProduction(payload)
      .then(response => {
        toast.success('Production rate overridden successfully', { autoClose: 1000 });
        // this.getProductionRate(this.openProductionRatePopup, true);
        this.openProductionRatePopup();
        FireboardUtils.addNetworkLogs(response);
      })
      .catch(error => this.handleErrorPopup(error));
  };

  onChangeMode = mode => {
    if (mode === modeEnums.CUBBY_MANAGER) {
      const { history } = this.props;
      history && history.push({
        pathname: '/cubbyManager',
        state: {
          parentRoute: 'fireboard',
        },
      });
    } else if (mode === modeEnums.ORDER_STATUS_MANAGER) {
      const { history } = this.props;
      history && history.push({
        pathname: '/orderStatusManager',
        state: {
          parentRoute: 'fireboard',
        },
      });
    } else if (mode === modeEnums.TABLE_DELIVERY || mode === modeEnums.GPS_LOCATION) {
      const pathname = mode === modeEnums.TABLE_DELIVERY ? '/tableDelivery' : '/gpsLocationDelivery';
      const { history } = this.props;
      history && history.push({
        pathname,
        state: {
          parentRoute: 'fireboard',
          mode: mode,
        },
      });
    } else {
      this.setState({ currentMode: mode, popup: undefined }, () => this.toggleSelection());
    }
  };

  toggleIncludeUnavailable = () => {
    this.setState(prevState => ({
      includeUnavailable: !prevState.includeUnavailable,
    }));
  };

  onPressManageCubby = () => {
    const { selectedItem } = this.state;
    const [order0] = selectedItem?.orders || [];
    const { storeCubbySlotId } = order0 || {};
    if (!storeCubbySlotId) {
      this.cubbyLayoutPopupType = 'Assign';
      this.setState({ popup: { type: 'cubbyLayout' } });
    } else {
      this.setState({ popup: { type: 'cubbyMenu' } });
    }
  };

  onCubbyMenuPress = type => {
    switch (type) {
      case 'moveFromSlot':
        this.cubbyLayoutPopupType = 'Move';
        this.setState({ popup: { type: 'cubbyLayout' } });
        break;
      case 'clearFromSlot':
        this.clearSlot();
        break;
      case 'pickedUp':
        this.orderPickedUp();
        break;
      default:
        console.warn('case not handled!!!');
        break;
    }
  };

  getChecksForCubby = () => {
    const checks = Array.from(this.checks.values());
    const formattedChecks = checks.map(check => {
      const [order0] = check?.orders || [];
      const slot = this.storeCubbySlotsMap.has(order0?.storeCubbySlotId) ? this.storeCubbySlotsMap.get(order0?.storeCubbySlotId) : {};
      const slotName = slot?.name || '';
      return {
        checkNumber: check.checkNumber,
        id: check.id,
        checkHeaderId: check.checkHeaderId,
        deliverTo: FireboardUtils.getDeliverTo(check),
        sourceType: check.sourceType,
        orderStatusId: check.orderStatusId,
        orders: check.orders,
        slotName: slotName,
      };
    });
    return formattedChecks || [];
  };

  refreshCubby = () => {
    const checks = this.getChecksForCubby();
    const { reduxProps: { storeInfo } } = this.props;
    const { storeCubby } = storeInfo?.data || {};
    const twoDimensionSlot = FireboardUtils.getCubbySlotsData(storeCubby, checks);
    this.storeCubbySlotsMap = FireboardUtils.buildStoreCubbyHashTable(storeCubby);
    this.setState({ twoDimensionSlot });
  };

  onMoveSlotOrder = selectedSlots => {
    const { reduxProps: { storeInfo } } = this.props;
    const { id: storeId } = storeInfo?.data || {};
    const { checkHeaderId } = this.state?.selectedItem || {};
    const slotIds = [...selectedSlots.keys()];
    const slotId = slotIds[0];
    const slots = [...selectedSlots.values()];
    const [slot0] = slots || []
    const slotName = slot0?.name || '';
    const payload = {
      storeId,
      checkHeaderId,
      storeCubbySlotId: slotId
    };
    const spinnerMsg = this.cubbyLayoutPopupType === 'Assign' ? 'Assigning slot' : 'Moving order';
    const toastMsg = this.cubbyLayoutPopupType === 'Assign' ? `Slot ${slotName} is assigned` : `Order is moved to slot ${slotName}`;
    this.callCubbyAssignApi(payload, spinnerMsg, toastMsg);
  };

  clearSlot = () => {
    const { reduxProps: { storeInfo } } = this.props;
    const { id: storeId } = storeInfo?.data || {};
    const { checkHeaderId, orders } = this.state?.selectedItem || {};
    const [order0] = orders || [];
    const slot = this.storeCubbySlotsMap.has(order0?.storeCubbySlotId) ? this.storeCubbySlotsMap.get(order0?.storeCubbySlotId) : {};
    const slotName = slot?.name || '';

    const callback = () => {
      const payload = {
        storeId,
        checkHeaderId,
        storeCubbySlotId: null
      };
      this.callCubbyAssignApi(payload, 'Clearing slot', `Slot ${slotName} is cleared`);
    };

    const popup = getPopupConfig('error');
    popup.heading = 'Confirmation';
    popup.message = `This will clear the order from slot ${slotName}. Do you want to continue?`;
    popup.buttons = [
      {
        text: constants.no,
        onClick: () => this.closePopup(),
      },
      {
        text: constants.yes,
        onClick: () => callback && callback(),
      },
    ];
    this.setState({ popup });
  };

  callCubbyAssignApi = (payload, spinnerMsg, toastMsg) => {
    this.getPopup('spinner', spinnerMsg);
    API.cubbyAssign(payload)
      .then(response => {
        this.state.popup = undefined;
        const updatedCheck = response.data;
        this.checks.set(updatedCheck.id, CommonUtil.parseCheckFromRedis(updatedCheck));
        this.refreshCubby();
        toast.success(toastMsg, { autoClose: 1000 });
        FireboardUtils.addNetworkLogs(response);
      })
      .catch(error => this.handleErrorPopup(error));
  };

  orderPickedUp = () => {
    const { reduxProps: { storeInfo } } = this.props;
    const { id: storeId } = storeInfo?.data || {};
    const { checkHeaderId, orders } = this.state?.selectedItem || {};
    const [order0] = orders || [];
    const slot = this.storeCubbySlotsMap.has(order0?.storeCubbySlotId) ? this.storeCubbySlotsMap.get(order0?.storeCubbySlotId) : {};
    const slotName = slot?.name || '';

    const callback = () => {
      const payload = {
        storeId,
        checkHeaderId,
        counter: false,
      };
      this.getPopup('spinner', 'Marking order as picked up');
      API.orderPickedUp(payload)
        .then(response => {
          this.state.popup = undefined;
          const updatedCheck = response.data;
          this.checks.set(updatedCheck.id, CommonUtil.parseCheckFromRedis(updatedCheck));
          this.refreshCubby();
          toast.success('Marked order as picked up', { autoClose: 1000 });
          FireboardUtils.addNetworkLogs(response);
        })
        .catch(error => this.handleErrorPopup(error));
    };

    const popup = getPopupConfig('error');
    popup.heading = 'Confirmation';
    popup.message = `This will mark the order in slot ${slotName} as picked up. Do you want to continue?`;
    popup.buttons = [
      {
        text: constants.no,
        onClick: () => this.closePopup(),
      },
      {
        text: constants.yes,
        onClick: () => callback && callback(),
      },
    ];
    this.setState({ popup });
  };

  startIntervalForTimeUpdate = () => {
    this.stopIntervalForTimeUpdate();
    this.elapsedTimer = setInterval(() => {
      this.toggleSelection();
    }, 60 * 1000);
  };

  stopIntervalForTimeUpdate = () => {
    this.elapsedTimer && clearInterval(this.elapsedTimer);
    this.elapsedTimer = null;
  };

  viewGuestLocationOnMap = () => {
    this.setState({ popup: { type: 'viewOnMap' } })
  };

  onRequestRefreshGuestGPS = () => {
    const oldPopup = this.state.popup;

    const callback = () => {
      this.getPopup('spinner', "Sending SMS to request guest location");
      const { checkHeaderId } = this.state?.selectedItem || {};
      API.textToGetLocation(checkHeaderId)
        .then(response => {
          this.setState({ popup: oldPopup })
          FireboardUtils.addNetworkLogs(response);
        })
        .catch(error => this.handleErrorPopup(error));
    };

    const popup = getPopupConfig('error');
    popup.heading = 'Confirmation';
    popup.message = 'This will send a text message to the guest requesting their location. Do you want to continue?';
    popup.buttons = [
      {
        text: constants.no,
        onClick: () => this.setState({ popup: oldPopup }),
      },
      {
        text: constants.yes,
        onClick: () => callback && callback(),
      },
    ];
    this.setState({ popup });
  };

  onOrderDelivered = check => {
    const { reduxProps: { storeInfo } } = this.props;
    const { id: storeId } = storeInfo?.data || {};
    const { checkHeaderId } = check || {};
    const payload = {
      storeId,
      checkHeaderId
    };
    this.getPopup('spinner', "Marking order as delivered");
    API.gpsLocationPickedUp(payload)
      .then(response => {
        this.setState({
          popup: undefined,
          selectedItem: {},
          items: [],
        });
        this.updateCheckAfterApiCall(response.data);
        FireboardUtils.addNetworkLogs(response);
      })
      .catch(error => this.handleErrorPopup(error));
  };

  updateCheckAfterApiCall = updatedCheck => {
    const { managerMode, prepTime } = this.state;
    if (!managerMode && this.showFutureOrders) {
      const dueTime = CommonUtil.getDueTime(updatedCheck);
      const newUpdatedCheck = {
        ...CommonUtil.parseCheckFromRedis(updatedCheck),
        isNew: false,
        elapsedTime: FireboardUtils.getElapsedTime(updatedCheck, prepTime),
        dueTime: new Date(dueTime).getTime(),
        dueTimeDisplay: dueTime,
      };
      const list = this.futureCheckItems.filter(c => c.id !== updatedCheck.id);
      this.futureCheckItems = [...list, newUpdatedCheck];
    } else {
      this.checks.set(updatedCheck.id, CommonUtil.parseCheckFromRedis(updatedCheck));
    }
    this.toggleSelection(true);
  };

  onOpenUpdateGuestInformationModal = () => {
    this.setState({ popup: { type: 'updateGuestInformation' } });
  };

  onUpdateGuestInformation = guestInfo => {
    const { reduxProps: { storeInfo } } = this.props;
    const { id: storeId } = storeInfo?.data || {};
    const { selectedItem } = this.state;
    const { checkHeaderId } = selectedItem || {};
    const payload = {
      storeId,
      checkHeaderId,
      ...guestInfo,
    };
    this.getPopup('spinner', "Updating guest information");
    API.updateGuestInformation(payload)
      .then(response => {
        this.setState({ popup: undefined });
        this.updateCheckAfterApiCall(response.data);
        FireboardUtils.addNetworkLogs(response);
      })
      .catch(error => this.handleErrorPopup(error));
  };

  markAsSeeCounter = () => {
    const { reduxProps: { storeInfo } } = this.props;
    const { id: storeId } = storeInfo?.data || {};
    const { checkHeaderId } = this.state?.selectedItem || {};
    const payload = {
      storeId,
      checkHeaderId,
      counter: true,
    };
    this.invokeOrderPickedUpApi(payload, 'Marking order as picked up');
  };

  onOpenSelectModePopup = () => {
    this.setState({ popup: { type: 'switchMode' } });
  };

  onClickSms = seatId => {
    this.seatId = seatId;
    this.onHandleSms();
  };

  invokeOrderPickedUpApi = (payload, spinnerMsg) => {
    this.getPopup('spinner', spinnerMsg);
    API.orderPickedUp(payload)
      .then(response => {
        this.setState({ popup: undefined });
        this.updateCheckAfterApiCall(response.data);
        FireboardUtils.addNetworkLogs(response);
      })
      .catch(error => this.handleErrorPopup(error));
  };

  markOrderAsPickedUp = () => {
    const { reduxProps: { storeInfo } } = this.props;
    const { id: storeId } = storeInfo?.data || {};
    const { checkHeaderId } = this.state?.selectedItem || {};
    const payload = {
      storeId,
      checkHeaderId,
      counter: false,
    };
    this.invokeOrderPickedUpApi(payload, 'Marking order as picked up');
  };

  launchExternalApp = () => {
    try {
      const { reduxProps: { storeInfo, deviceApi, deviceApiData } } = this.props;
      const { brandId, brandExternalId, id, storeNumber, thirdPartyAppUrl } = storeInfo?.data || {};
      const { deviceId, deviceExternalId } = deviceApi?.data || deviceApiData || {};
      // const urlPlaceholders = {
      //   brandId: brandId,
      //   brandExternalId: brandExternalId,
      //   storeId: id,
      //   storeNumber: storeNumber,
      //   deviceId: deviceId,
      //   deviceExternalId: deviceExternalId,
      //   employeeId: this.employeeIdForExternalApp,
      // };
      if (thirdPartyAppUrl) {
        let webUrl = thirdPartyAppUrl;
        // Object.entries(urlPlaceholders).forEach(([key, value]) => {
        //   webUrl = webUrl.replace(`{${key}}`, value || null);
        // });
        EventEmitter.launchExternalApp(webUrl);
      }
    } catch (error) {
      console.error(`error in external app launch - ${error}`);
    }
  };

  buildSensorsHashTable = () => {
    const { reduxProps: { storeInfo } } = this.props;
    const { sensors } = storeInfo?.data || {};
    this.sensorsMap = FireboardUtils.buildSensorsHashTable(sensors);
  };

  setMultipleStores = (socketContext) => {
    const fbVenueMode = socketContext?.fbVenueMode || false;
    const multipleStores = socketContext?.multipleStores || [];
    const venueName = socketContext?.venueName || '';
    let stores = [allStoreOption];
    multipleStores.forEach(st => stores.push({ value: st.id, label: st.name }));
    this.setState({ fbVenueMode, venueName, multipleStores: stores });
  };

  onChangeVenueStore = (selectedVenueStore) => {
    this.setState({ selectedVenueStore }, () => this.toggleSelection());
  };

  goToBulkTextToPay = () => {
    const filteredChecks = this.checksRowData;
    this.bulkTextToPayChecks = [];
    //filter checks that qualify for text to pay eligibility criteria 
    filteredChecks.forEach(check => {
      const excludeCheck = check.orderStatusId !== 5 && check.orderStatusId !== 8;
      if (check.unpaidAmount > 0 && excludeCheck) {
        this.bulkTextToPayChecks.push(check);
      }
    });
    if (this.bulkTextToPayChecks.length > 0) {
      this.setState({
        popup: { type: 'bulkTextToPay' }
      });
    } else {
      this.getPopup('error', 'Alert', 'There are no checks!!!');
    }
  };

  openResendReceiptPopup = () => {
    this.setState({ popup: { type: 'resendReceipt' } });
  };

  receiptHandler = (type, ticket) => {
    this.ticket = ticket;
    if (type === 'print') {
      const { payload, request, loadingMsg } = this.getReceiptPayload('print');
      //this.invokeReceiptApi(request, payload, loadingMsg);
    } else if (type === 'email') {
      this.setState({ popup: { type: 'emailReceipt' } });
    } else if (type === 'text') {
      if (ticket?.memberId) { //ticket has member id available
        this.getPopup("spinner", "Getting member details.", null);
        //invoke endpoint to get phone number
        API.getMemberDetails({ memberId: ticket.memberId })
          .then(response => {
            this.setState({
              popup: {
                type: 'smsReceipt',
                metaData: response.data,
              },
            });
            FireboardUtils.addNetworkLogs(response);
          })
          .catch(error => {
            this.setState({ popup: { type: 'smsReceipt' } });
            console.error('error in getting member details - ', error);
          });
      } else {//ticket has no member id available
        this.setState({ popup: { type: 'smsReceipt' } });
      }
    }
  };

  emailReceiptHandler = email => {
    let { payload, request, loadingMsg } = this.getReceiptPayload('email');
    payload = {
      ...payload,
      emailAddress: email,
    };
    this.invokeReceiptApi(request, payload, loadingMsg);
  };

  smsReceiptHandler = data => {
    const { phoneNumber, selectedCountry } = data || {};
    let { payload, request, loadingMsg } = this.getReceiptPayload('text');
    payload = {
      ...payload,
      phoneNumber: FireboardUtils.inputUnFormattedPhnNum(phoneNumber, selectedCountry.iso2),
      countryCode: selectedCountry.dialCode.split('+')[1],
    };
    this.invokeReceiptApi(request, payload, loadingMsg);
  };

  openTicketDetails = (ticket) => {
    const { history, reduxProps } = this.props;
    const { storeInfo } = reduxProps || {};
    const { defaultPreAuthTipPercentage } = storeInfo?.data || {};
    const { supportsGratuityForPreAuth } = storeInfo?.data?.serverAppFeatures || {};
    const { selectedItem } = this.state;
    history.push({
      pathname: '/fireboardPreAuth',
      state: {
        item: JSON.stringify(selectedItem),
        selectedTicket: ticket,
        defaultPreAuthTipPercentage: defaultPreAuthTipPercentage,
        supportsGratuityForPreAuth: supportsGratuityForPreAuth,
        deviceTypeId: 15,
      }
    });
  }

  getReceiptPayload = type => {      
    // const { reduxProps: { storeInfo } } = this.props;
    // const { id: storeId } = storeInfo?.data || {};
    const { dispatchResendPrintAction, reduxProps } = this.props;
    const { storeInfo, deviceApi } = reduxProps;
    const { selectedItem } = this.state;
    const { id: checkHeaderId, storeId } = selectedItem || {};
    const { ticketId } = this.ticket || {};
    const { deviceId } = deviceApi?.data || {};
    const payload = {
      checkHeaderId,
      ticketId,
      storeId,
      deviceId
    };
    
    let loadingMsg, request;
    if (type === 'print') {
      loadingMsg = constants.printReceiptSpinner;
      // request = API.receiptPrint;
      dispatchResendPrintAction({
        storeId: storeInfo.data.id,
        deviceId: deviceId,
        ticketId: ticketId,
        checkHeaderId: checkHeaderId,
      })
    } else if (type === 'email') {
      loadingMsg = constants.emailReceiptSpinner;
      request = API.emailReceipt;
    } else if (type === 'text') {
      loadingMsg = constants.smsReceiptSpinner;
      request = API.smsReceipt;
    }
    return { payload, request, loadingMsg };
  };

  invokeReceiptApi = (request, payload, loadingMsg) => {
    this.getSpinner('spinner', loadingMsg, null);
    request(payload)
      .then(response => {
        this.setState({ popup: undefined });
        FireboardUtils.addNetworkLogs(response);
      })
      .catch(error => this.handleErrorPopup(error));
  };

  openCaptureSeatNamePopup = (seatId) => {
    this.seatId = seatId;
    this.setState({ popup: { type: 'captureSeatName' } });
  };

  onUpdateSeatName = (seatName) => {
    const { reduxProps: { storeInfo, login, deviceApi, deviceApiData } } = this.props;
    const { id: storeId } = storeInfo?.data || {};
    const { id: employeeId } = login?.data || {};
    const { deviceId } = deviceApi?.data || deviceApiData || {};
    const { selectedItem } = this.state;
    const { id: checkHeaderId, } = selectedItem || {};
    const payload = {
      storeId,
      deviceId: deviceId,
      employeeId: employeeId || null,
      employeeCard: null,
      checkHeaderId,
      seatId: this.seatId,
      name: seatName,
    };
    this.seatId = null;
    this.getSpinner('spinner', constants.updatingSeatName, null);
    API.renameSeat(payload)
      .then(response => {
        this.setState({ popup: undefined });
        this.updateCheckAfterApiCall(response.data);
        FireboardUtils.addNetworkLogs(response);
      })
      .catch(error => this.handleErrorPopup(error));
  };

  validateLogin = (loginId, indentifier) => {
    const { reduxProps: { deviceApi } } = this.props;
    const { deviceId } = deviceApi?.data;
    const payload = {
      deviceId,
      appVersion: version,
      employeeCode: loginId,
      employeeCard: null,
      jobId: null,
      manager: false,
    };
    this.getPopup('spinner', constants.loginLoadingHeading, null);
    API.login(payload, true)
      .then(response => {
        const { id: employeeId } = response.data;
        if (indentifier === checkEnum.ID_CHECK) {
          this.onMarkAsAgeVerified(employeeId);
        } else if (indentifier === checkEnum.AGE_RESTRICTED_FOR_CHECK) {
          this.invokeAgeRestrictedItemsForCheck(employeeId);
        } else if (indentifier === checkEnum.AGE_RESTRICTED_FOR_SEAT) {
          this.invokeAgeRestrictedItemsForSeat(employeeId);
        } else if (indentifier === checkEnum.STORE_PRODUCTION) {
          this.onOverrideStoreProduction(employeeId);
        } else {
          this.setState({ popup: undefined });
        }
        FireboardUtils.addNetworkLogs(response);
      })
      .catch(error => this.handleErrorPopup(error));
  };

  markAsAgeVerified = () => {
    this.setState({
      popup: {
        type: 'managerLogin',
        metaData: { indentifier: checkEnum.ID_CHECK }
      }
    });
  };

  onMarkAsAgeVerified = (employeeId) => {
    //If ageVerificationStatus is 5. Action is Clear ID Check, then send confirmIdCheck value as false
    //If ageVerificationStatus is 1. Action is Confirm ID Check, then send confirmIdCheck value as true
    const { reduxProps: { storeInfo, deviceApi, deviceApiData } } = this.props;
    const { id: storeId } = storeInfo?.data || {};
    const { deviceId } = deviceApi?.data || deviceApiData || {};
    const { selectedItem } = this.state;
    const { id: checkHeaderId, orders } = selectedItem || {};
    const [order0] = orders || [];
    const { ageVerificationStatus } = order0 || {};
    const payload = {
      storeId,
      deviceId: deviceId,
      employeeId: employeeId || null,
      checkHeaderId,
      confirmIdCheck: ageVerificationStatus === 5 ? false : true,
    };
    const spinnerMsg = ageVerificationStatus === 5 ? constants.clearingIdCheck : constants.confirmingIdCheck;
    this.getSpinner('spinner', spinnerMsg, null);
    API.ageVerification(payload)
      .then(response => {
        this.setState({ popup: undefined });
        this.updateCheckAfterApiCall(response.data);
        FireboardUtils.addNetworkLogs(response);
      })
      .catch(error => this.handleErrorPopup(error));
  };

  onUpdateAgeRestrictedItemsForCheck = () => {
    this.setState({
      popup: {
        type: 'managerLogin',
        metaData: { indentifier: checkEnum.AGE_RESTRICTED_FOR_CHECK }
      }
    });
  };

  invokeAgeRestrictedItemsForCheck = (employeeId) => {
    const { reduxProps: { storeInfo, deviceApi, deviceApiData } } = this.props;
    const { id: storeId } = storeInfo?.data || {};
    const { deviceId } = deviceApi?.data || deviceApiData || {};
    const { selectedItem } = this.state;
    const { id: checkHeaderId, orders } = selectedItem || {};
    const [order0] = orders || [];
    const { disableAgeRestricted } = order0 || {};
    const payload = {
      storeId,
      deviceId,
      checkHeaderId,
      employeeId: employeeId || null,
      disableAgeRestricted: !disableAgeRestricted,
    };
    const spinnerMsg = disableAgeRestricted
      ? constants.enablingAgeRestrictedItems
      : constants.disablingAgeRestrictedItems;
    this.getSpinner('spinner', spinnerMsg, null);
    API.ageRestrictedItemsUpdateForCheck(payload)
      .then(response => {
        this.setState({ popup: undefined });
        this.updateCheckAfterApiCall(response.data);
        FireboardUtils.addNetworkLogs(response);
      })
      .catch(error => this.handleErrorPopup(error));
  };

  onUpdateAgeRestrictedItemsForSeat = (seatId, disableAgeRestricted) => {
    this.ageRestrictedItemsForSeat = { seatId, disableAgeRestricted };
    this.setState({
      popup: {
        type: 'managerLogin',
        metaData: { indentifier: checkEnum.AGE_RESTRICTED_FOR_SEAT }
      }
    });
  };

  invokeAgeRestrictedItemsForSeat = (employeeId) => {
    //if disableAgeRestricted is true - send false to endpoint
    //if disableAgeRestricted is false - send true to endpoint
    const { reduxProps: { storeInfo, deviceApi, deviceApiData } } = this.props;
    const { id: storeId } = storeInfo?.data || {};
    const { deviceId } = deviceApi?.data || deviceApiData || {};
    const { selectedItem } = this.state;
    const { id: checkHeaderId } = selectedItem || {};
    const { seatId, disableAgeRestricted } = this.ageRestrictedItemsForSeat || {};
    const payload = {
      storeId,
      deviceId,
      checkHeaderId,
      seatId: seatId,
      employeeId: employeeId || null,
      disableAgeRestricted: !disableAgeRestricted,
    };
    const spinnerMsg = disableAgeRestricted
      ? constants.enablingAgeRestrictedItems
      : constants.disablingAgeRestrictedItems;
    this.getSpinner('spinner', spinnerMsg, null);
    API.ageRestrictedItemsUpdateForSeat(payload)
      .then(response => {
        this.setState({ popup: undefined });
        this.updateCheckAfterApiCall(response.data);
        FireboardUtils.addNetworkLogs(response);
      })
      .catch(error => this.handleErrorPopup(error));
  };

  get viewProps() {
    const {
      snoozeEnabled,
      selectedItem = {},
      items = [],
      popup,
      isDevEnvironment,
      showNotifications,
      value,
      showSearchBox,
      orderStatusType,
      selectedDate,
      futureOrdersList,
      productionTime,
      prepTime,
      countStatus,
      notificationControlEnabled,
      fromFooter,
      preAuthItem,
      managerMode,
      pendingCheckItems,
      activeMgrFilter,
      counters,
      orderType,
      selectedReason,
      reasonsList,
      currentView,
      selectedTable,
      selectedShape,
      sensorData,
      sortFilter,
      outOfStockItems,
      outOfStockMode,
      outOfStockSearchList,
      loginInfo,
      isCustomSmsType,
      customSmsList,
      updatedShapes,
      venueOrder,
      foodRunner,
      batchPreauth,
      pagination,
      currentMode,
      includeUnavailable,
      twoDimensionSlot,
      fbVenueMode,
      multipleStores,
      selectedVenueStore,
      productionOverrideReasons,
    } = this.state || {};
    const {
      reduxProps: { storeInfo, currencyInfo, fbNetworkLogs, deviceApi, deviceApiData, deviceInfo },
      history,
    } = this.props || {};
    const { deviceName, deviceGroup } = deviceApi?.data || deviceApiData || {};
    const { supportsTipsOnTotalAmount = false, suppressTipsOnFireBoard = false, supportsGratuityForPreAuth } = storeInfo && storeInfo.data ? storeInfo.data.serverAppFeatures : {};
    const { onlineOrderAdvanceLimit = 1, defaultPreAuthTipPercentage, enableGpsLocation, latitude, longitude, supportPhoneNumber } = storeInfo?.data || {};
    const notificationsToBeDisplayed = this.getNotificationsToBeDisplayed();
    const newNotificationCount = Array.isArray(notificationsToBeDisplayed)
      ? notificationsToBeDisplayed.filter(n => n.isNew).length
      : 0;
    const { rnDevEnv, iso2 } = currencyInfo || {};
    const { networkLogs } = fbNetworkLogs || {};
    const checkFilters = {
      orderType: orderType,
      activeCheckFilter: this.activeCheckFilter,
      checkSourceTypes: this.checkSourceTypes,
      checkOrderTypes: this.checkOrderTypes,
      checkRevenueTypes: this.checkRevenueTypes,
      checkSensorGroupTypes: this.checkSensorGroupTypes,
    };
    return {
      currency: this.currency,
      rnDevEnv,
      iso2,
      popup,
      isDevEnvironment,
      baseUrl: window.location.origin || '',
      setSelectedCheck: this.setSelectedCheck,
      selectedItem,
      checksRowData: this.checksRowData,
      notificationsData: this.notificationsData,
      onUpdate: this.onUpdate,
      items,
      supportsTipsOnTotalAmount,
      suppressTipsOnFireBoard,
      showMemberDetailPopup: this.showMemberDetailPopup,
      onPrintPress: this.onPrintPress,
      setNotifications: this.setNotifications,
      showNotifications: showNotifications,
      onOpenSearchBox: this.onOpenSearchBox,
      onSearchReset: this.onSearchReset,
      value: value,
      showSearchBox: showSearchBox,

      resetFilterCalendar: this.resetFilterCalendar,

      handleChange: this.handleChange,
      searchChecks: this.searchChecks,
      removeNewTag: this.removeNewTag,
      isFutureOrderType: this.showFutureOrders,
      showCalendar: this.showCalendar,
      onDateChange: this.onDateChange,
      selectedDate: selectedDate,
      onlineOrderAdvanceLimit,
      futureOrdersList: futureOrdersList,
      storeInfo: storeInfo.data,
      markItemAPaid: this.markItemAPaid,
      onHandleTextToPay: this.onHandleTextToPay,
      updateOrderStatus: this.updateOrderStatus,
      joinCheck: this.joinCheck,
      onPrint: this.printCheck,
      onHandleSms: this.onHandleSms,
      onQRGenerate: this.generateQR,
      textToCheckIn: this.textToCheckIn,
      onHandleSend: this.onHandleSend,
      onClose: this.closePopup,
      notificationControlEnabled: notificationControlEnabled,
      fromFooter,
      goToCheck: this.goToCheck,
      pendingItems: pendingCheckItems,
      acknowledgeIdCheck: this.acknowledgeIdCheck,
      // showApprovalReasonsPopup: this.showApprovalReasonsPopup,
      selectedReason: selectedReason,
      reasonsList: reasonsList,
      resetSelectedReason: this.resetSelectedReason,
      // submitReason: this.submitReason,
      onPressReason: this.onPressReason,
      managerFilters: filterInfo,
      activeMgrFilter,

      // FOOTER PROPS
      supportNumber: FireboardUtils.formattedPhoneNumber(supportPhoneNumber, iso2),
      isDev: true,
      buildVersion: version,
      invokeScanToPay: this.invokeScanToPay,
      invokeCheckIn: this.invokeCheckIn,
      invokeTextToPay: this.invokeTextToPay,
      onFooterIconPress: this.onFooterIconPress,
      setNotificationType: this.setNotificationType,
      setCounterType: this.setCounterType,
      setSortType: this.setSortType,
      sortFilter,

      // HEADER PROPS
      onChange: this.headerPress,
      onSaveFilter: this.onSaveFilter,
      counters,
      orderType,
      onOrderTypeChange: this.onOrderTypeChange,
      orderStatusType,
      onOrderStatusChange: this.onOrderStatusChange,
      onToggleCount: this.onToggleCount,
      curbCount: this.getNewCheckCount(SourceTypes.CurbSide),
      onlineCount: this.getNewCheckCount(SourceTypes.Online),
      walkupCount: this.getNewCheckCount(SourceTypes.WalkUp),
      textToPayCount: this.getNewCheckCount(SourceTypes.TextToPay),
      curbPendingCount: this.getPendingCount(SourceTypes.CurbSide),
      onlinePendingCount: this.getPendingCount(SourceTypes.Online),
      walkupPendingCount: this.getPendingCount(SourceTypes.WalkUp),
      textToPayPendingCount: this.getPendingCount(SourceTypes.TextToPay),
      preAuthCount: this.getPreauthCount(),
      prepTime: prepTime,
      production: productionTime,
      countStatus: countStatus,
      totalNotificationsCount:
        Array.isArray(notificationsToBeDisplayed)
          ? notificationsToBeDisplayed.filter(n => n).length
          : 0,
      notificationCount: newNotificationCount,
      snoozeNotifications: this.snoozeInterval,
      snoozeEnabled,
      orderTypes: this.getOrderTypes(),
      onResyncCheck: this.onResyncCheck,
      onPreAuth: this.onPreAuth,
      preAuthItem: preAuthItem,
      tipSubmit: this.tipSubmit,
      managerMode: managerMode,
      onLogout: this.onLogout,
      getManagerNotifications: this.getManagerNotifications(),
      dismissPopup: this.dismissPopup,
      currentView,
      selectedTable,
      tables: this.getTables,
      toggleView: this.toggleView,
      selectedShape,
      onSelectShape: this.onSelectShape,
      closeShapeInfoPopup: this.closeShapeInfoPopup,
      sensorData,
      onLoginPress: this.onLoginPress,
      defaultPreAuthTipPercentage,
      supportsGratuityForPreAuth,
      networkLogs,
      outOfStockItems,
      outOfStockMode,
      outOfStockSearchList,
      onOutOfStockItemsPress: this.onOutOfStockItemsPress,
      searchOutOfStockItems: this.searchOutOfStockItems,
      getOutOfStock: this.getOutOfStockList,
      updateItemStock: this.updateItemStock,
      loginInfo,
      doPairWatch: this.doPairWatch,
      onMarketplaceStatusPress: this.onMarketplaceStatusPress,
      history,
      openPaymentHistory: this.openPaymentHistory,
      rePostPayment: this.rePostPayment,
      isCustomSmsType,
      customSmsList,
      onChangeSmsType: this.onChangeSmsType,
      viewErrorOrders: this.viewErrorOrders,
      acknowledgeErrorOrder: this.acknowledgeErrorOrder,
      shapes: updatedShapes,
      sensorGroupsList: this.sensorGroupsList,
      openEditSensorGroupPopup: this.openEditSensorGroupPopup,
      sensorGroup: this.sensorGroup,
      updateSensorGroup: this.updateSensorGroup,
      closeEditSensorGroupPopup: this.closeEditSensorGroupPopup,
      venueOrder,
      foodRunner,
      onToggleOrderSettings: this.onToggleOrderSettings,
      notifyOrderPrepared: this.notifyOrderPrepared,
      notifyOrderReady: this.notifyOrderReady,
      notifyOrderStatus: this.notifyOrderStatus,
      batchPreauth,
      onClickBulkPreAuth: this.onClickBulkPreAuth,
      bulkPreAuthChecks: this.bulkPreAuthChecks,
      updateCheckAfterPreauthTipSubmit: this.updateCheckAfterPreauthTipSubmit,
      deviceName,
      sortModel: this.sortModel,
      updateSortModel: this.updateSortModel,
      onPressRedeemVoucher: this.onPressRedeemVoucher,
      onRedeemVoucher: this.onRedeemVoucher,
      navigateToSensor: this.navigateToSensor,
      deviceGroup: deviceGroup,
      onVoucherSearch: this.onVoucherSearch,
      searchedVoucher: this.searchedVoucher,
      onRedeemSearchedVoucher: this.onRedeemSearchedVoucher,
      productionRateList: CommonUtil.filterPrepAndProductionByCurrentTime(this.productionRateList),
      productionRate: this.productionRateForEdit,
      productionOverrideReasons: productionOverrideReasons,
      openProductionRatePopup: this.openProductionRatePopup,
      onEditProductionRate: this.onEditProductionRate,
      onManageOverrides: this.onManageOverrides,
      pagination,
      currentMode,
      onChangeMode: this.onChangeMode,
      checkFilters,
      includeUnavailable,
      toggleIncludeUnavailable: this.toggleIncludeUnavailable,
      onPressManageCubby: this.onPressManageCubby,
      twoDimensionSlot,
      onCubbyMenuPress: this.onCubbyMenuPress,
      cubbyLayoutPopupType: this.cubbyLayoutPopupType,
      onMoveSlotOrder: this.onMoveSlotOrder,
      enableGpsLocation,
      latitude,
      longitude,
      viewGuestLocationOnMap: this.viewGuestLocationOnMap,
      onRequestRefreshGuestGPS: this.onRequestRefreshGuestGPS,
      onOrderDelivered: this.onOrderDelivered,
      onOpenUpdateGuestInformationModal: this.onOpenUpdateGuestInformationModal,
      onUpdateGuestInformation: this.onUpdateGuestInformation,
      markAsSeeCounter: this.markAsSeeCounter,
      onOpenSelectModePopup: this.onOpenSelectModePopup,
      onClickSms: this.onClickSms,
      enabledMarkAsPickedUpOption: true,
      markOrderAsPickedUp: this.markOrderAsPickedUp,
      activeCheckFilter: this.activeCheckFilter,
      sensorsMap: this.sensorsMap,
      fbVenueMode,
      multipleStores,
      selectedVenueStore,
      onChangeVenueStore: this.onChangeVenueStore,
      bulkTextToPayChecks: this.bulkTextToPayChecks,
      openResendReceiptPopup: this.openResendReceiptPopup,
      receiptHandler: this.receiptHandler,
      emailReceiptHandler: this.emailReceiptHandler,
      smsReceiptHandler: this.smsReceiptHandler,
      receiptTicket: this.ticket,
      onTabChange: this.onTabChange,
      openCaptureSeatNamePopup: this.openCaptureSeatNamePopup,
      onUpdateSeatName: this.onUpdateSeatName,
      sendPendingItems: this.sendPendingItems,
      enableAgeVerification: this.enableAgeVerification,
      markAsAgeVerified: this.markAsAgeVerified,
      enableAgeRestrictedOrderingForCheck: this.enableAgeRestrictedOrderingForCheck,
      onUpdateAgeRestrictedItemsForCheck: this.onUpdateAgeRestrictedItemsForCheck,
      enableAgeRestrictedOrderingForSeat: this.enableAgeRestrictedOrderingForSeat,
      onUpdateAgeRestrictedItemsForSeat: this.onUpdateAgeRestrictedItemsForSeat,
      openTicketDetails: this.openTicketDetails,
    };
  }

  render() {
    const viewProps = this.viewProps;
    return <View {...viewProps} />;
  }
}

const mapStateToProps = (reduxProps) => ({
  reduxProps,
});

const mapDispatchToProps = (dispatch) => ({
  dispatchUpdateNotification: (payload) => {
    dispatch(updateNotification(payload));
  },
  dispatchUpdateStatusType: (payload) => {
    dispatch(updateStatusType(payload));
  },
  dispatchUpdateNotificationType: (payload) => {
    dispatch(updateNotificationType(payload));
  },
  dispatchAcknowledgeNotification: (payload) => {
    dispatch(acknowledgeNoticationAction(payload));
  },
  dispatchPrintAction: (payload) => {
    dispatch(tableReceipt(payload));
  },
  dispatchResendPrintAction: (payload) => {
    dispatch(printReceipt(payload))
  },
  dispatchUpdateCheckSort: (payload) => {
    dispatch(updateCheckSort(payload));
  },
  dispatchLogin: (storeId, code, employeeCard, managerMode) => {
    dispatch(loginAction(storeId, version, code, employeeCard, null, managerMode));
  },
  dispatchUpdateCompState: (payload) => {
    dispatch(updateComponentState(payload));
  },
  dispatchRetryPOS: (payload) => {
    dispatch(retryPOSPayment(payload));
  },
  disptachUpdateFbCheckFilters: (payload) => {
    dispatch(updateFbCheckFilters(payload));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(withSocketContext(Fireboard));
